// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-08T21:33:15.420Z
// Property: Astoria (ID: 6767906449166811)
// Collections: 29 amenities, 3 floorplans (live), 42 photos, 42 POIs, 10 reviews, 2 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5742705921490944",
  "multihub_property_id": "6767906449166811",
  "property_external_id": "n891yfp",
  "property_zillow_url": "https://www.zillow.com/apartments/fife-wa/astoria/5gjrg2/",
  "property_apartments_url": "https://www.apartments.com/astoria-apartments-fife-wa/n891yfp/",
  "property_google_business_url": "https://www.google.com/maps/place/Astoria+Apartments/data=!4m2!3m1!1s0x0:0x9a3a940b2e0744f0?sa=X&ved=2ahUKEwixxea16KeSAxW2wzgGHTtgK_0Q_BJ6BAgYEAA&hl=en&gl=us",
  "property_linkedin_url": "https://www.linkedin.com/company/astoria-healthcare-center",
  "property_hubspot_id": "41607311715",
  "property_crm_software": "Anyone Home",
  "property_pm_software": "AIM",
  "property_pm_info": "184AST",
  "property_status": null,
  "property_slug": "astoria",
  "property_name": "Astoria",
  "property_website_url": "https://www.liveattheastoria.com/",
  "property_domain": "https://liveattheastoria.com/",
  "property_address": "5700 23rd Street East",
  "property_full_address": "5700 23rd St E, Fife, WA 98424, USA",
  "property_address_1": "5700 23rd Street East",
  "property_address_2": null,
  "property_address_city": "Fife",
  "property_address_state": "WA",
  "property_address_zip_full": null,
  "property_address_zip": "98424",
  "property_address_country": "US",
  "property_address_county": "Pierce County",
  "property_neighborhood_address": "East Fife",
  "property_address_latitude": "47.23567569999999",
  "property_address_longitude": "-122.3528937",
  "property_email": null,
  "property_phone": "(253) 447-5892",
  "property_call_tracking_phone": "855-343-2539",
  "property_company_name": "Apartment Management Consultants",
  "property_company_url": "https://www.liveamc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Astoria in Fife, WA, a vibrant lifestyle awaits amidst spacious one, two, and three-bedroom floor plans. Enjoy our inviting clubhouse, state-of-the-art fitness center, and a dog-friendly park alongside BBQ spots and a playground. Unveil your perfect sanctuary—check our availability or schedule a tour today! ",
  "property_long_description": "Welcome to Astoria, your perfect apartment community nestled in the heart of Fife, WA! Discover a range of beautifully designed floor plans, including spacious one-bedroom, two-bedroom, and three-bedroom apartments that cater to your unique lifestyle. Each home is thoughtfully crafted with modern finishes and ample living space, ideal for both relaxation and entertaining.\n\nAt Astoria, we prioritize your comfort and convenience with a suite of exceptional amenities. Our inviting clubhouse is the perfect spot for social gatherings or quiet afternoons, while the state-of-the-art fitness center allows you to maintain your active lifestyle right at home. Need to focus? Our business center has you covered, making remote work a breeze. \n\nPet lovers will appreciate our dedicated dog wash station and expansive dog park—your furry friends will feel right at home! For outdoor fun, take advantage of our BBQ area to grill with friends or enjoy quality time at the playground with your little ones. Plus, our ample parking and package locker area provide added convenience, ensuring all your needs are met.\n\nAstoria is more than just a place to live; it's a community where you can thrive. With its prime location in Fife, you'll have easy access to shopping, dining, and recreational activities. Don’t wait any longer to find your new home! Browse our availability today or schedule a tour to visit our vibrant community. Experience the lifestyle you deserve at Astoria!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d20b7-f842-736d-ba0f-909019ad49d0.webp",
  "property_featured_image_media": {
    "alt_text": "Astoria apartment complex with outdoor lounge area, fire pit, and grilling station.",
    "public_id": "019d20b7-f842-736d-ba0f-909019ad49d0",
    "storage_key": "property/6767906449166811/019d20b7-f842-736d-ba0f-909019ad49d0.webp",
    "width": 2048,
    "height": 1365
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "126",
  "property_year_built": "1982",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "99.20634920634922",
  "property_admin_fee": "300",
  "property_application_fee": null,
  "property_fees_deposit_info": "\t$500.00 Standard Deposit (Deposit may increase based on screening results)",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "200",
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Dogs and cats are welcome (breed restrictions apply). Maximum of 2 pets per unit.",
  "property_pet_policy_description": "Dogs and cats are welcome (breed restrictions apply). Maximum of 2 pets per unit. One-time non‑refundable fee: $300 per pet. Refundable deposit: $200 per pet. Monthly pet rent: $50 per pet.",
  "property_petpolicy_info": "\nDog/Cats\tYes\nMax Pets\t2\nMonthly Pet Rent\t$50/pet\nNon-refundable fees for either Dog or Cat\t$300 Non-Refundable fee per pet\nRefundable deposits for either Dog or Cat\t$200 Refundable deposit per pet\nPet Restrictions\tBreed Restrictions",
  "property_online_leasing_url": "https://www.myrentalapplication.com/index/amcastoria",
  "property_resident_portal_url": "https://astoria.goprisma.com/auth/login",
  "property_apply_now_url": "https://myrentalapplication.com/index/amcastoria",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d1-6aef-7771-b393-4f0f5a8b887d.webp",
  "property_primary_logo_media": {
    "alt_text": "Astoria Apartment Homes logo",
    "public_id": "019d02d1-6aef-7771-b393-4f0f5a8b887d",
    "storage_key": "property/6767906449166811/019d02d1-6aef-7771-b393-4f0f5a8b887d.webp",
    "width": 229,
    "height": 90
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d3-8bcd-771b-b067-d0bb77733a50.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Astoria apartment homes logo",
    "public_id": "019d02d3-8bcd-771b-b067-d0bb77733a50",
    "storage_key": "property/6767906449166811/019d02d3-8bcd-771b-b067-d0bb77733a50.webp",
    "width": 229,
    "height": 90
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d3-9583-775f-8768-7a4754e01456.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Astoria apartment homes logo",
    "public_id": "019d02d3-9583-775f-8768-7a4754e01456",
    "storage_key": "property/6767906449166811/019d02d3-9583-775f-8768-7a4754e01456.webp",
    "width": 229,
    "height": 90
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-5da7-768a-9221-bb30f19666be.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
  "property_company_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c4-532b-737e-bc65-d92182ca8ca4",
    "storage_key": "company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
    "width": 640,
    "height": 309
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Logo for Apartment Management Consultants with a house icon.",
    "public_id": "019f6696-c195-7642-9eb0-0a4d0423bad7",
    "storage_key": "company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
    "width": 320,
    "height": 154
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019f6696-f877-771a-b04d-e0c2089d85b0",
    "storage_key": "company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
    "width": 320,
    "height": 154
  },
  "property_primary_color": "#EF4A25",
  "property_secondary_color": "#7FB5A3",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "620 - 1,050 sq ft",
  "property_sqft_min": "620",
  "property_sqft_max": "1,050",
  "property_price_range": "$1445 - $2750",
  "property_price_min": "1445",
  "property_price_max": "2750",
  "property_available_units": 1,
  "property_facebook_url": "https://www.facebook.com/AstoriaAptHomes",
  "property_instagram_url": "https://www.instagram.com/astoriaapts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJS_4RGzb_kFQR8EQHLguUOpo",
  "property_youtube_url": "https://www.youtube.com/shorts/8xWKDTC7LsQ",
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Second+Chance+Apartments&find_loc=Fife%2C+WA",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Astoria",
  "property_home_romance_title": "Embrace a Life of Love in Your New Community",
  "property_home_amenities_blurb": "Welcome to Astoria in Fife, WA—where modern living meets comfort. Choose from spacious one, two, or three-bedroom floor plans and enjoy vibrant community amenities like a refreshing fitness center, inviting clubhouse, and a fun-filled playground. Your ideal lifestyle awaits at Astoria—embrace the extraordinary today!",
  "property_home_floorplans_blurb": "At Astoria in Fife, WA, your ideal living space awaits. Our thoughtfully designed apartments feature diverse floor plans to suit every lifestyle, from cozy nooks to spacious retreats. Browse our available homes today and elevate your life with comfort and style right at your fingertips!",
  "property_home_gallery_blurb": "Welcome to Astoria in Fife, WA—where modern living meets comfort. Choose from stylish one to three-bedroom apartments, enjoy top-notch amenities like a fitness center, dog park, and vibrant clubhouse. Picture yourself living here, surrounded by everything you need for a fulfilling lifestyle. Your perfect home awaits!",
  "property_home_neighborhood_blurb": "Welcome to Astoria in vibrant Fife, WA, where spacious one, two, and three-bedroom apartments await! Nestled near cultural gems like the Museum of Glass and Tacoma Art Museum, you'll relish the blend of urban living and serene parks. Dive into the local scene and uncover your new favorites today!",
  "property_home_reviews_blurb": "Welcome to Astoria in Fife, WA, where residents rave about our “friendly atmosphere and spacious living.” Experience a vibrant community that goes beyond just a place to live. See what our residents have to say about living at our community, and find your perfect home today!",
  "property_neighborhood_blurb": "Nestled in vibrant Fife, WA, Astoria offers more than just stylish one, two, and three-bedroom apartments. Uncover local gems like the Museum of Glass, Washington State History Museum, and picturesque Wright Park. Dive into a world of culture, nature, and community right at your doorstep! Experience life at Astoria today.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Astoria in Fife, WA, indulge in a lifestyle that blends comfort with convenience. From our inviting clubhouse and state-of-the-art fitness center to a dedicated dog park and BBQ areas, every amenity is designed for relaxation and enjoyment. Unwind and make every moment count in your perfect new home.",
  "property_applynow_blurb": "Welcome to Astoria in vibrant Fife, WA, where spacious one, two, and three-bedroom apartments meet exceptional amenities. Enjoy a life of comfort with our clubhouse, fitness center, dog park, and more. Ready to elevate your lifestyle? Lease your perfect home online today!",
  "property_contactus_blurb": "At Astoria in Fife, WA, we offer an array of thoughtfully designed apartments, including one, two, and three-bedroom floor plans tailored to your lifestyle. Whether you seek cozy elegance or spacious comfort, our community is the ideal backdrop for your next chapter. Have questions? Contact our leasing team today!",
  "property_faqs_blurb": "At Astoria in Fife, WA, your ideal home awaits with thoughtfully designed one, two, and three-bedroom floor plans. From spacious interiors to vibrant community living, every detail is crafted for your comfort. Have questions? Browse our FAQs page for valuable insights about our community and lifestyle.",
  "property_floorplans_blurb": "At Astoria in Fife, WA, your ideal living space awaits. Choose from our thoughtfully designed one, two, or three-bedroom floor plans, each tailored for comfort and style. Browse our available apartment homes to uncover the perfect layout that fits your lifestyle and makes every day extraordinary.",
  "property_gallery_blurb": "At Astoria in Fife, WA, envision vibrant living in thoughtfully designed one, two, and three-bedroom apartments. Unwind in our welcoming clubhouse, energize in the fitness center, or enjoy playful afternoons at the dog park and playground. Picture yourself thriving here—start your journey with a glimpse into our photo gallery!",
  "property_interactivemap_blurb": "At Astoria in Fife, WA, your ideal living space awaits. Choose from thoughtfully designed one, two, or three-bedroom floor plans, all nestled within a vibrant community. With amenities like a fitness center, dog park, and BBQ area, life here blends convenience with comfort. Use our interactive community map to begin your journey today!",
  "property_pets_blurb": "At Astoria in Fife, WA, your furry friends will feel right at home! With spacious apartments and a welcoming pet policy, you can enjoy life together. Bring your dogs or cats (with a few breed restrictions), and make every moment memorable in our vibrant community designed for both you and your pets.",
  "property_referafriend_blurb": "At Astoria in Fife, WA, we believe great friends make great neighbors. With spacious one, two, and three-bedroom floor plans, there’s room for everyone to thrive. Refer a friend today and share the joy of living in a vibrant community built for connection and comfort!",
  "property_residentaccess_blurb": "At Astoria in Fife, WA, our thoughtfully designed one, two, and three-bedroom apartments cater to every lifestyle. Access your resident portal to streamline rent payments, schedule maintenance, and enhance your living experience. Dive into a community where convenience meets comfort, making every day feel just right.",
  "property_reviews_blurb": "At Astoria in Fife, WA, our residents rave about their experience, saying it feels like “home the moment you walk in.” Dive into their heartfelt testimonials and discover what makes our community truly special. See what our residents have to say about living at our community!",
  "property_created_at": "1762201577693",
  "property_scheduletour_blurb": "At Astoria in Fife, WA, our thoughtfully designed one, two, and three-bedroom apartments offer the perfect blend of comfort and style. Experience a vibrant community life that goes beyond four walls. Ready to envision your new home? Schedule a tour today and see what our residents love about living here!",
  "property_thankyou_blurb": "Thank you for reaching out to Astoria in Fife, WA! We can't wait to share our diverse floor plans—whether you're envisioning a cozy one-bedroom or a spacious three-bedroom suite, your ideal home awaits. Stay tuned for a prompt response from our dedicated team!",
  "property_virtualtours_blurb": "Experience the essence of modern living at Astoria in Fife, WA. Choose from spacious one, two, or three-bedroom floor plans designed for comfort and style. Dive into an immersive virtual tour today to see all that our vibrant community has to offer—your new home awaits!",
  "property_copyright": "2025 All Rights Reserved. Astoria",
  "property_seo_title_home": "Apartments in Fife, WA | Astoria Apartments",
  "property_seo_description_home": "Discover newly renovated 1 & 2 bedroom apartments in Fife, WA at Astoria. Enjoy upgraded interiors, private patios, and easy access to I-5, Tacoma, and Seattle.",
  "property_seo_title_floorplans": "1 and 2 Bedroom Apartments in Fife, WA | Floor Plans",
  "property_seo_description_floorplans": "Explore spacious one- and two-bedroom apartments for rent in Fife, WA at Astoria. Find your ideal floor plan and tour our community today!",
  "property_seo_title_amenities": "Amenities | Fife, WA Apartments for Rent",
  "property_seo_description_amenities": "Enjoy upgraded appliances, wood-burning fireplaces, private patios, a dog spa, fenced bark park, and more at Astoria Apartments in Fife, WA.",
  "property_seo_title_gallery": "Fife Apartments for Rent | Gallery",
  "property_seo_description_gallery": "Browse photos of Astoria Apartments in Fife, WA. Explore renovated interiors, community amenities, outdoor spaces, and spacious apartment homes near Tacoma.",
  "property_seo_title_virtualtours": "Newly Renovated Apartments in Fife, WA | Virtual Tour",
  "property_seo_description_virtualtours": "Take a virtual tour of Astoria Apartments in Fife, WA. Explore renovated apartment homes, pet-friendly amenities, and outdoor spaces from anywhere.",
  "property_seo_title_interactivemap": "Fife Apartments | Interactive Leasing",
  "property_seo_description_interactivemap": "Explore availability, pricing, and lease your new apartment online at Astoria Apartments in Fife, WA with our interactive leasing experience.",
  "property_seo_title_neighborhood": "Apartments Near Tacoma, WA | Neighborhood",
  "property_seo_description_neighborhood": "Live in Fife, WA with convenient access to Tacoma, Seattle, downtown Fife, and I-5, SR-167, SR-512, and Highway 18 at Astoria Apartments.",
  "property_seo_title_contact": "Fife, WA Apartments | Contact Us",
  "property_seo_description_contact": "Contact Astoria Apartments to learn more about our one and two bedroom apartments for rent in Fife, WA or schedule your personal tour today.",
  "property_seo_title_faqs": "FAQs | Apartments in Fife, WA",
  "property_seo_description_faqs": "Get answers to your questions at Astoria in Fife, WA! From floor plans to amenities like a dog park and clubhouse, we've got you covered.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Fife, WA",
  "property_seo_description_reviews": "Join the Astoria community in Fife, WA, where residents thrive! Check out their reviews and discover our stylish homes and top-notch amenities.",
  "property_seo_title_applynow": "Apartments for Rent in Fife, WA | Apply Now",
  "property_seo_description_applynow": "Apply online for your new apartment at Astoria in Fife, WA. Complete your application securely and begin your next chapter today.",
  "property_seo_title_residentaccess": "Resident Portal | Astoria Apartments in Fife, WA",
  "property_seo_description_residentaccess": "Access the Astoria Apartments resident portal to pay rent, submit maintenance requests, and manage your account online.",
  "property_seo_title_referafriend": "Refer A Friend | Astoria",
  "property_seo_description_referafriend": "Refer a friend to Astoria in Fife, WA! Enjoy a vibrant community where great friends become great neighbors. Share the love today!",
  "property_seo_title_scheduletour": "Apartments for Rent in Fife, WA | Schedule a Tour",
  "property_seo_description_scheduletour": "Schedule a tour of Astoria Apartments in Fife, WA. Explore our renovated one and two bedroom apartment homes and community amenities in person.",
  "property_seo_title_privacy": "Privacy Policy | Astoria",
  "property_seo_description_privacy": "At Astoria in Fife, WA, your privacy is our priority. Dive into transparency with our privacy policy and understand how we safeguard your information.",
  "property_seo_title_accessibility": "Website Accessibility | Astoria",
  "property_seo_description_accessibility": "Experience inclusive living at Astoria in Fife, WA. Our commitment to accessibility ensures everyone feels at home. Join us in fostering a welcoming community!",
  "property_seo_title_sitemap": "Sitemap | Astoria",
  "property_seo_description_sitemap": "Unearth the beauty of Astoria in Fife, WA! Navigate our sitemap to find the perfect home and embrace a vibrant living experience. Your new adventure awaits!",
  "property_seo_title_thankyou": "Thank You | Astoria | Fife Apartments for Rent",
  "property_seo_description_thankyou": "Thank you for contacting Astoria Apartments in Fife, WA. A member of our leasing team will be in touch with you soon.",
  "property_seo_title_pets": "Pet-friendly Apartments for Rent in Fife, WA | Amenities",
  "property_seo_description_pets": "Astoria offers pet-friendly apartments in Fife, WA with a dog spa and fenced agility bark park. Review our pet policy and welcome your furry companion.",
  "property_updated_at": "1791293659239",
  "amenities": [
    {
      "id": "custom_4d2d259b-0c39-46e3-a2ae-b426234a1824",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "Entertainment System, Business Center, Complimentary WiFi",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2e78b415-91c8-45af-89d3-cfc29e9178a7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "Fully Equipped, Free Weights",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_41050e67-cec9-4cef-8117-71d65fe6dd83",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "Your Office Away From Home",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_50e2c3eb-ffc8-40e8-8fd8-82d59f4e46f7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8e72bbe0-62c9-442b-9218-7610a9062fcc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "external_id": "false",
      "title": "Dog Park",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_17517607-ea6b-4923-a1b8-1e10d1383197",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "external_id": "false",
      "title": "Dog Wash Station",
      "amount": "false",
      "description": "Indoor Setting for Your Convenience",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3498fd09-2e8b-4f32-9a58-24d9ba2fd730",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "external_id": "false",
      "title": "Package Locker Area",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e51d5b41-5a22-4514-8a8c-99556f76a61b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "external_id": "false",
      "title": "Carports",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8b3e4566-7d7c-4665-a40b-af6755eb3f99",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "external_id": "false",
      "title": "Common Laundry Facilities",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_746dc040-50fc-46d1-9c29-13cfcf064a89",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "external_id": "false",
      "title": "Washer and dryer in unit",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fa25c15c-2478-4b4b-b103-951e3c5acb1d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "external_id": "false",
      "title": "Upgraded appliances",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a301a9f6-0dee-49d2-a34a-8cf2f90bce63",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "external_id": "false",
      "title": "Spacious floor plans",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a62a46e3-4c3f-4c38-a979-e4c536f524e8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "external_id": "false",
      "title": "Wood-burning fireplaces",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_774bcaac-eb58-4bd4-a7be-e9d9b8ea3530",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling fans",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dfdccd8d-6833-4306-9473-3b4c645d9b00",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "external_id": "false",
      "title": "Patio/balcony",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b84c2974-7468-489c-b056-4891909c0b6e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "external_id": "false",
      "title": "Storage space",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7be8f7b8-1a37-4348-8ef9-065d6aa7f4b1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "external_id": "false",
      "title": "Pre-installed high speed internet",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2d4361ba-1527-4bb2-bd57-4dd6f30e8b2a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "external_id": "false",
      "title": "Fire pit",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d938d57a-23cb-42e3-831b-894c8090ccf3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "external_id": "false",
      "title": "BBQ area",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2614493c-b488-46cd-b7e1-8b8bbff075af",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "external_id": "false",
      "title": "Dog wash",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c9904c03-f795-4ef2-8a2e-ab42fa9f6e6d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bf23742e-c445-487f-82ed-61c8aa5ffd9b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8fa82481-bcfd-40c4-a31e-8321ecc9832c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "external_id": "false",
      "title": "Sport Court",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e4b7a932-ae03-47b9-9c72-8cb6655243fa",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "external_id": "false",
      "title": "Car Vacuum",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c134507b-57ed-43ec-8495-3eba4dfb4fc0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a2f2766a-4c57-40f5-8012-20a893636431",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless-Steel Appliances",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0574dc20-3738-4f7b-b11c-86bf9b2fab61",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "external_id": "false",
      "title": "Pantry",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a72eaf81-3876-49e8-b311-dbee2f90eae7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "external_id": "false",
      "title": "Qaurtz Countertops",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8731cc94-df52-4a43-aaa9-8f6432ef7fdb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "external_id": "false",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_87ae5486-d91b-47e3-9d1d-023d1e18fca8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f3889-5465-70f0-9a8f-0907ef2a441a.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with BBQ grill, umbrellas, and lounge chairs, surrounded by lush landscaping.",
        "public_id": "019f3889-5465-70f0-9a8f-0907ef2a441a",
        "storage_key": "property/6767906449166811/019f3889-5465-70f0-9a8f-0907ef2a441a.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy outdoor living with this communal BBQ and seating area, perfect for gathering with neighbors and friends. Features a modern grill, comfortable seating, and beautiful landscaping.",
      "link": "",
      "alt_text": "Outdoor seating area with BBQ grill, umbrellas, and lounge chairs, surrounded by lush landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_57ecc146-00d9-4303-9106-db084c807200",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f3889-dd5e-77b8-8f50-b799630f012b.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with fire pit, grilling station, and seating.",
        "public_id": "019f3889-dd5e-77b8-8f50-b799630f012b",
        "storage_key": "property/6767906449166811/019f3889-dd5e-77b8-8f50-b799630f012b.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy community gatherings in our outdoor lounge area, complete with a fire pit, grilling station, and comfortable seating.",
      "link": "",
      "alt_text": "Outdoor lounge area with fire pit, grilling station, and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_aee70344-4c5c-4a9e-921c-8e56b6f36bdd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f3889-ea85-74f9-b924-fe16409e618b.webp",
      "image_media": {
        "alt_text": "Astoria apartment building exterior with landscaping",
        "public_id": "019f3889-ea85-74f9-b924-fe16409e618b",
        "storage_key": "property/6767906449166811/019f3889-ea85-74f9-b924-fe16409e618b.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Welcome to Astoria Apartments, featuring a beautifully landscaped exterior and a welcoming building entrance.",
      "link": "",
      "alt_text": "Astoria apartment building exterior with landscaping",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0ce76044-7322-4fea-b6ad-30080b41c504",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f388a-06da-7799-8985-3d616f409112.webp",
      "image_media": {
        "alt_text": "Outdoor stainless steel grill with granite countertop and stone base, next to a trash can.",
        "public_id": "019f388a-06da-7799-8985-3d616f409112",
        "storage_key": "property/6767906449166811/019f388a-06da-7799-8985-3d616f409112.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking with our built-in stainless steel grill, perfect for gathering with friends and family.",
      "link": "",
      "alt_text": "Outdoor stainless steel grill with granite countertop and stone base, next to a trash can.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_422d4844-d733-4362-806c-c231805d4f17",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f388a-0cdd-724d-9363-87a62fe7ec7c.webp",
      "image_media": {
        "alt_text": "Fenced-in dog park with agility equipment and benches.",
        "public_id": "019f388a-0cdd-724d-9363-87a62fe7ec7c",
        "storage_key": "property/6767906449166811/019f388a-0cdd-724d-9363-87a62fe7ec7c.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Our pet-friendly community features a dedicated dog park with agility equipment, providing a safe and fun space for your furry companions to play and socialize.",
      "link": "",
      "alt_text": "Fenced-in dog park with agility equipment and benches.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6635723e-7749-4741-ac7d-02ec1c4894d0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f3889-baa2-743c-87f6-605ad1e073bd.webp",
      "image_media": {
        "alt_text": "Playground with colorful equipment and blue benches in front of apartment buildings.",
        "public_id": "019f3889-baa2-743c-87f6-605ad1e073bd",
        "storage_key": "property/6767906449166811/019f3889-baa2-743c-87f6-605ad1e073bd.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at the community playground, perfect for children to play and residents to relax on the nearby benches.",
      "link": "",
      "alt_text": "Playground with colorful equipment and blue benches in front of apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_99a68734-7abe-425c-8de8-8d1b4bf8597a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f388a-3455-745e-92cb-b374fefbcc1e.webp",
      "image_media": {
        "alt_text": "Community courtyard with fire pit and outdoor grilling area at sunset.",
        "public_id": "019f388a-3455-745e-92cb-b374fefbcc1e",
        "storage_key": "property/6767906449166811/019f388a-3455-745e-92cb-b374fefbcc1e.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Gather around the fire pit or utilize the outdoor grilling station in this beautiful community courtyard, perfect for evening relaxation and socializing.",
      "link": "",
      "alt_text": "Community courtyard with fire pit and outdoor grilling area at sunset.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ca17ae37-b473-4e0a-9a55-5b54b103b7de",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f3889-df5e-70ef-b499-a7cfca91a3f0.webp",
      "image_media": {
        "alt_text": "Community coffee and snack bar with a large 'A' logo visible in the background.",
        "public_id": "019f3889-df5e-70ef-b499-a7cfca91a3f0",
        "storage_key": "property/6767906449166811/019f3889-df5e-70ef-b499-a7cfca91a3f0.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy complimentary coffee and snacks at our community coffee bar. A perfect place to relax and recharge.",
      "link": "",
      "alt_text": "Community coffee and snack bar with a large 'A' logo visible in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b0b0317b-325c-4c9f-815d-4143d1d46b5b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f3889-cef5-731c-9227-33bdeb3834de.webp",
      "image_media": {
        "alt_text": "Modern co-working space with a gym visible through glass.",
        "public_id": "019f3889-cef5-731c-9227-33bdeb3834de",
        "storage_key": "property/6767906449166811/019f3889-cef5-731c-9227-33bdeb3834de.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Collaborate or work remotely in our stylish co-working lounge, featuring a fully equipped fitness center for your convenience.",
      "link": "",
      "alt_text": "Modern co-working space with a gym visible through glass.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5d996fd6-fa58-44b2-a634-7d10b9ab9467",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f388a-014f-74ee-aa24-0b8ab4bef2be.webp",
      "image_media": {
        "alt_text": "Business center with computers, seating, and a coffee bar.",
        "public_id": "019f388a-014f-74ee-aa24-0b8ab4bef2be",
        "storage_key": "property/6767906449166811/019f388a-014f-74ee-aa24-0b8ab4bef2be.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy our convenient business center, equipped with computers and a coffee bar, perfect for work or relaxation.",
      "link": "",
      "alt_text": "Business center with computers, seating, and a coffee bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d85eb544-b0ea-403f-b3cd-c46784375984",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f3889-a8cd-7710-ba05-89a025780c85.webp",
      "image_media": {
        "alt_text": "A brightly lit and modern lobby with blue walls, a grey sofa, two orange accent chairs, a white coffee table, and a television mounted on the wall.",
        "public_id": "019f3889-a8cd-7710-ba05-89a025780c85",
        "storage_key": "property/6767906449166811/019f3889-a8cd-7710-ba05-89a025780c85.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lobby, featuring comfortable seating, modern decor, and a large television for your entertainment.",
      "link": "",
      "alt_text": "A brightly lit and modern lobby with blue walls, a grey sofa, two orange accent chairs, a white coffee table, and a television mounted on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cde9bccb-ac8a-4f0f-b08d-e7874647058d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f3889-971c-71c0-ae79-8fab9f33ab66.webp",
      "image_media": {
        "alt_text": "Business center with computers, red stools, and amenities.",
        "public_id": "019f3889-971c-71c0-ae79-8fab9f33ab66",
        "storage_key": "property/6767906449166811/019f3889-971c-71c0-ae79-8fab9f33ab66.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Work or study in our modern business center, equipped with computers and comfortable seating, offering a quiet space for residents.",
      "link": "",
      "alt_text": "Business center with computers, red stools, and amenities.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5b55590f-9f6b-441a-8d6d-679ba299b626",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f3889-a8f0-737b-9ab9-926a5c731bcf.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, elliptical, weight machines, dumbbells, and medicine balls.",
        "public_id": "019f3889-a8f0-737b-9ab9-926a5c731bcf",
        "storage_key": "property/6767906449166811/019f3889-a8f0-737b-9ab9-926a5c731bcf.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with cardio machines, free weights, and strength training equipment.",
      "link": "",
      "alt_text": "Gym with treadmills, elliptical, weight machines, dumbbells, and medicine balls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_073abae8-e852-492a-bfa1-0ec2378b3529",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f388a-26df-772b-9cba-7e7ef1f73327.webp",
      "image_media": {
        "alt_text": "K9 Hydro Therapy Room with large bathing tub, grooming table, and dog-themed decor.",
        "public_id": "019f388a-26df-772b-9cba-7e7ef1f73327",
        "storage_key": "property/6767906449166811/019f388a-26df-772b-9cba-7e7ef1f73327.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Pamper your furry friends in our K9 Hydro Therapy Room, featuring a professional grooming tub and ample space for baths and styling.",
      "link": "",
      "alt_text": "K9 Hydro Therapy Room with large bathing tub, grooming table, and dog-themed decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_991e1935-689b-439b-90fd-f65c6f828b21",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f388a-22ff-76dd-87a7-c62510a1fb45.webp",
      "image_media": {
        "alt_text": "Laundry room with multiple washers and dryers.",
        "public_id": "019f388a-22ff-76dd-87a7-c62510a1fb45",
        "storage_key": "property/6767906449166811/019f388a-22ff-76dd-87a7-c62510a1fb45.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "On-site laundry facilities available for residents, equipped with multiple washers and dryers.",
      "link": "",
      "alt_text": "Laundry room with multiple washers and dryers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_169837db-76f6-47ee-9566-f22c832ab2ba",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d1-6c92-7628-bcfa-04013ef7b896.webp",
      "image_media": {
        "alt_text": "K9 Hydro Therapy Room and Spa Room signage with dog graphics. Includes stainless steel bathing tub.",
        "public_id": "019d02d1-6c92-7628-bcfa-04013ef7b896",
        "storage_key": "property/6767906449166811/019d02d1-6c92-7628-bcfa-04013ef7b896.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "The Astoria apartment community offers a K9 Hydro Therapy Room and Spa Room for residents and their pets, featuring a professional grooming tub.",
      "link": "",
      "alt_text": "K9 Hydro Therapy Room and Spa Room signage with dog graphics. Includes stainless steel bathing tub.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_090e26ae-3995-4e15-9232-2a92bf481095",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f3889-9af9-772f-bb63-7fefaa83d00c.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with manicured landscaping in the foreground.",
        "public_id": "019f3889-9af9-772f-bb63-7fefaa83d00c",
        "storage_key": "property/6767906449166811/019f3889-9af9-772f-bb63-7fefaa83d00c.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Discover charming apartment buildings surrounded by beautiful landscaping, offering a welcoming community atmosphere.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with manicured landscaping in the foreground.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_df64c398-5c22-443e-a2af-c8749b6c1d76",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f3889-8ecf-74d6-97ab-181a110e3a00.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with blue and gray siding and manicured landscaping.",
        "public_id": "019f3889-8ecf-74d6-97ab-181a110e3a00",
        "storage_key": "property/6767906449166811/019f3889-8ecf-74d6-97ab-181a110e3a00.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Charming apartment buildings featuring a blend of blue and gray siding, surrounded by lush green trees and vibrant yellow bushes.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with blue and gray siding and manicured landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f438d46e-cb66-4a66-bbd7-8e0a951839f7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f388a-2997-71bb-a121-90964c90fd62.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with covered parking and trees.",
        "public_id": "019f388a-2997-71bb-a121-90964c90fd62",
        "storage_key": "property/6767906449166811/019f388a-2997-71bb-a121-90964c90fd62.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Exterior view of the apartment complex, showcasing the building facades and ample covered parking spaces.",
      "link": "",
      "alt_text": "Apartment building exterior with covered parking and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2db9b748-5843-4137-8dd7-4af531132447",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f388a-2344-77ab-a696-e9be78b86101.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with surrounding trees and a nearby sports field.",
        "public_id": "019f388a-2344-77ab-a696-e9be78b86101",
        "storage_key": "property/6767906449166811/019f388a-2344-77ab-a696-e9be78b86101.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Aerial view showcasing the apartment complex's layout, surrounded by lush greenery and adjacent to a sports complex, offering a serene living environment.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings with surrounding trees and a nearby sports field.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2d0e5968-f582-4e6e-ade0-cfe0390a2818",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f388a-0c05-70a0-aa38-70207879e89c.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with covered parking and surrounding landscape.",
        "public_id": "019f388a-0c05-70a0-aa38-70207879e89c",
        "storage_key": "property/6767906449166811/019f388a-0c05-70a0-aa38-70207879e89c.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Expansive aerial view showcasing the apartment complex with its various buildings, covered parking areas, and well-maintained landscaping, all set against a backdrop of distant mountains.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings with covered parking and surrounding landscape.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0ed3c5ca-d94f-4490-ba6e-810fed2a8609",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f3889-f86f-7044-9e3a-848fc205e446.webp",
      "image_media": {
        "alt_text": "Exterior aerial view of apartment buildings with a courtyard and seating area.",
        "public_id": "019f3889-f86f-7044-9e3a-848fc205e446",
        "storage_key": "property/6767906449166811/019f3889-f86f-7044-9e3a-848fc205e446.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Aerial view showcasing the apartment buildings and beautifully landscaped courtyard with outdoor seating and fire pit.",
      "link": "",
      "alt_text": "Exterior aerial view of apartment buildings with a courtyard and seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9776bc1c-f395-4b3e-874b-825f6e107308",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f3889-caca-715d-9220-3b7374ee5a59.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings and community amenities, including a bocce ball court and outdoor seating area.",
        "public_id": "019f3889-caca-715d-9220-3b7374ee5a59",
        "storage_key": "property/6767906449166811/019f3889-caca-715d-9220-3b7374ee5a59.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Discover our vibrant community with beautifully landscaped grounds, a bocce ball court, and ample outdoor seating for relaxation and socializing.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings and community amenities, including a bocce ball court and outdoor seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_40081cfe-a05b-462d-8681-59475e4aa36b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f388a-1a80-77bd-96f2-08e9ff3b3dec.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and hardwood floors.",
        "public_id": "019f388a-1a80-77bd-96f2-08e9ff3b3dec",
        "storage_key": "property/6767906449166811/019f388a-1a80-77bd-96f2-08e9ff3b3dec.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this updated kitchen, featuring ample cabinet space, granite countertops, and modern appliances.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and hardwood floors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1c21fad3-dec9-4554-a85d-102ed232c987",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f3889-fe54-725a-bd1b-d0ec862255bc.webp",
      "image_media": {
        "alt_text": "Kitchenette with white cabinets and black stove.",
        "public_id": "019f3889-fe54-725a-bd1b-d0ec862255bc",
        "storage_key": "property/6767906449166811/019f3889-fe54-725a-bd1b-d0ec862255bc.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Compact kitchen area featuring white cabinetry, a stainless steel sink, dishwasher, and a black electric stove.",
      "link": "",
      "alt_text": "Kitchenette with white cabinets and black stove.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e729d286-de5f-4cdc-b214-d22fc7595bd4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f3889-aaea-773c-85ce-be5913d26c40.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, grey countertops, and stainless steel appliances.",
        "public_id": "019f3889-aaea-773c-85ce-be5913d26c40",
        "storage_key": "property/6767906449166811/019f3889-aaea-773c-85ce-be5913d26c40.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Experience a clean and functional kitchen space, perfect for preparing meals with modern white cabinetry, sleek countertops, and essential stainless steel appliances.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, grey countertops, and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9b0db2e5-ce99-4d15-bef4-75f0762a8318",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f3889-d0f3-763e-b4af-bbcc6506a696.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, stainless steel appliances, and a ceiling fan.",
        "public_id": "019f3889-d0f3-763e-b4af-bbcc6506a696",
        "storage_key": "property/6767906449166811/019f3889-d0f3-763e-b4af-bbcc6506a696.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring white cabinetry, a stainless steel sink, dishwasher, and a black stove. The space includes a ceiling fan and wood-look flooring.",
      "link": "",
      "alt_text": "Kitchen with white cabinets, stainless steel appliances, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f8940b54-204a-4989-963c-eabe35edb8a6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f3889-cb6c-70c7-b132-0a4481d6c781.webp",
      "image_media": {
        "alt_text": "Kitchen and dining area with a sliding glass door leading to an outdoor patio.",
        "public_id": "019f3889-cb6c-70c7-b132-0a4481d6c781",
        "storage_key": "property/6767906449166811/019f3889-cb6c-70c7-b132-0a4481d6c781.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Bright and airy kitchen and dining area with modern white cabinetry and dark wood flooring. Large sliding glass door provides access to an outdoor patio and views of the courtyard.",
      "link": "",
      "alt_text": "Kitchen and dining area with a sliding glass door leading to an outdoor patio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_37e6e632-e4e9-4944-8852-3f2b66c48634",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f3889-b3ad-77c9-9612-e4f067ad8990.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, gray backsplash, and wood-look flooring.",
        "public_id": "019f3889-b3ad-77c9-9612-e4f067ad8990",
        "storage_key": "property/6767906449166811/019f3889-b3ad-77c9-9612-e4f067ad8990.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy a bright and spacious kitchen featuring ample cabinet storage, modern finishes, and a sleek design. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, gray backsplash, and wood-look flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_76818dd6-e82e-4996-ac8a-8e565d81b319",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f3889-cf9a-76a8-8e60-ba1f69b5f1ef.webp",
      "image_media": {
        "alt_text": "Kitchen with stainless steel appliances and view of a living room with fireplace.",
        "public_id": "019f3889-cf9a-76a8-8e60-ba1f69b5f1ef",
        "storage_key": "property/6767906449166811/019f3889-cf9a-76a8-8e60-ba1f69b5f1ef.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy a fully equipped kitchen with modern stainless steel appliances, perfect for cooking and entertaining. The adjacent living room features a cozy fireplace.",
      "link": "",
      "alt_text": "Kitchen with stainless steel appliances and view of a living room with fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5c28c111-87dd-443c-b15b-9dda7de68a21",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f388a-2187-743b-a76d-4f29c12e71ed.webp",
      "image_media": {
        "alt_text": "Kitchen and living room with a fireplace and sliding glass door.",
        "public_id": "019f388a-2187-743b-a76d-4f29c12e71ed",
        "storage_key": "property/6767906449166811/019f388a-2187-743b-a76d-4f29c12e71ed.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring stainless steel appliances and a spacious living room with a cozy fireplace and ample natural light.",
      "link": "",
      "alt_text": "Kitchen and living room with a fireplace and sliding glass door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2cd3a839-b0f9-4e2e-acd5-05d2cf5066b6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f388a-2700-740c-81cb-ea8a93bd9174.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and sliding glass doors leading to an outdoor patio.",
        "public_id": "019f388a-2700-740c-81cb-ea8a93bd9174",
        "storage_key": "property/6767906449166811/019f388a-2700-740c-81cb-ea8a93bd9174.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a stone-accented fireplace and dark wood floors, with sliding glass doors that open to a scenic view of the grounds.",
      "link": "",
      "alt_text": "Living room with fireplace and sliding glass doors leading to an outdoor patio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_26c7407f-4548-40f6-89a5-9bcfeebfd920",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f3889-cdc5-738d-8751-7d6807d24954.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and stairs leading to the second floor.",
        "public_id": "019f3889-cdc5-738d-8751-7d6807d24954",
        "storage_key": "property/6767906449166811/019f3889-cdc5-738d-8751-7d6807d24954.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a cozy fireplace, dark wood-look flooring, and stairs leading to the upper level of the apartment.",
      "link": "",
      "alt_text": "Living room with fireplace and stairs leading to the second floor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_48b45288-9da4-4cd6-8918-66cf449de749",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f3889-8cf2-739e-95fb-bd57964e269a.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and vertical blinds",
        "public_id": "019f3889-8cf2-739e-95fb-bd57964e269a",
        "storage_key": "property/6767906449166811/019f3889-8cf2-739e-95fb-bd57964e269a.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a gas fireplace and sliding glass doors with vertical blinds, perfect for creating a warm and inviting atmosphere.",
      "link": "",
      "alt_text": "Living room with fireplace and vertical blinds",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f4ff69c9-97b6-4261-9bbf-faf80d7c37dc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f3889-ec00-77fc-a60b-7f5126bf57bc.webp",
      "image_media": {
        "alt_text": "Empty bedroom with carpet, a large window, and a ceiling light.",
        "public_id": "019f3889-ec00-77fc-a60b-7f5126bf57bc",
        "storage_key": "property/6767906449166811/019f3889-ec00-77fc-a60b-7f5126bf57bc.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "This unfurnished bedroom features plush carpeting, a large window with blinds allowing natural light, and a simple ceiling fixture. Ideal for personalization.",
      "link": "",
      "alt_text": "Empty bedroom with carpet, a large window, and a ceiling light.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0193a588-ddfc-4a46-8f89-561ed83e0c97",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f388a-2a00-760f-bc53-a91fe0f83280.webp",
      "image_media": {
        "alt_text": "Empty bedroom with beige walls, carpet, and a window overlooking the outside.",
        "public_id": "019f388a-2a00-760f-bc53-a91fe0f83280",
        "storage_key": "property/6767906449166811/019f388a-2a00-760f-bc53-a91fe0f83280.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "This unfurnished bedroom features neutral paint, plush carpeting, and a large window that lets in plenty of natural light.",
      "link": "",
      "alt_text": "Empty bedroom with beige walls, carpet, and a window overlooking the outside.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0087b090-1286-43ce-bd94-222c7e82c7f2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f388a-03b0-76e3-b972-1a892f2b9891.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a bathtub, shower, toilet, and vanity with a sink and mirror.",
        "public_id": "019f388a-03b0-76e3-b972-1a892f2b9891",
        "storage_key": "property/6767906449166811/019f388a-03b0-76e3-b972-1a892f2b9891.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Experience comfort and convenience in this well-appointed bathroom, featuring a sleek bathtub, shower, and modern vanity.",
      "link": "",
      "alt_text": "Modern bathroom with a bathtub, shower, toilet, and vanity with a sink and mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_54a012b8-519f-4de6-868a-7a0aba9bcbad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f3889-d43e-75de-a755-fe4cc3ab7219.webp",
      "image_media": {
        "alt_text": "A clean, neutral-toned bathroom with a toilet, sink, and vanity.",
        "public_id": "019f3889-d43e-75de-a755-fe4cc3ab7219",
        "storage_key": "property/6767906449166811/019f3889-d43e-75de-a755-fe4cc3ab7219.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Step into comfort and convenience in this well-appointed bathroom, featuring a modern vanity, sink, and toilet for your everyday needs.",
      "link": "",
      "alt_text": "A clean, neutral-toned bathroom with a toilet, sink, and vanity.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_df353b9e-d4ff-4239-8c95-8111dd03dda9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f3889-c9fd-751a-a172-8e07ee9ab14e.webp",
      "image_media": {
        "alt_text": "Modern bathroom with sink, toilet, and shower/tub combo.",
        "public_id": "019f3889-c9fd-751a-a172-8e07ee9ab14e",
        "storage_key": "property/6767906449166811/019f3889-c9fd-751a-a172-8e07ee9ab14e.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Step into this clean and contemporary bathroom, featuring a vanity with a sink, a toilet, and a white shower/tub combination.",
      "link": "",
      "alt_text": "Modern bathroom with sink, toilet, and shower/tub combo.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_04ec6c21-c12c-4a43-9a4c-49ff0898e7e3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f3889-f90a-7421-8fbf-e6fa32deb0f2.webp",
      "image_media": {
        "alt_text": "Stackable washer and dryer in a closet",
        "public_id": "019f3889-f90a-7421-8fbf-e6fa32deb0f2",
        "storage_key": "property/6767906449166811/019f3889-f90a-7421-8fbf-e6fa32deb0f2.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "In-unit stackable washer and dryer for your laundry needs.",
      "link": "",
      "alt_text": "Stackable washer and dryer in a closet",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_56ea5b97-c12e-4fcb-a91d-9122ed416779",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f388a-11e5-728c-8168-564065361b2a.webp",
      "image_media": {
        "alt_text": "Stackable washer and dryer in a closet",
        "public_id": "019f388a-11e5-728c-8168-564065361b2a",
        "storage_key": "property/6767906449166811/019f388a-11e5-728c-8168-564065361b2a.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Convenient in-unit stacked washer and dryer for easy laundry access within your apartment home.",
      "link": "",
      "alt_text": "Stackable washer and dryer in a closet",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_dcf16773-5ea2-4ab8-b4ba-28c23d500d8b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f3889-c601-70a8-a269-3d69c146b14e.webp",
      "image_media": {
        "alt_text": "Stackable washer and dryer with water heater in a closet.",
        "public_id": "019f3889-c601-70a8-a269-3d69c146b14e",
        "storage_key": "property/6767906449166811/019f3889-c601-70a8-a269-3d69c146b14e.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer for easy laundry access.",
      "link": "",
      "alt_text": "Stackable washer and dryer with water heater in a closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_cda8df3d-cf0e-4a0f-9f48-cc96352777b6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "poi_name": "Harvest Buffet",
      "poi_type": "Restaurants",
      "poi_address": "3121 S 38th St, Tacoma, WA 98409, USA",
      "poi_short_description": "Spacious, informal restaurant offering an all-you-can-eat buffet of typical Asian dishes & desserts.",
      "poi_long_description": "People say this buffet restaurant offers a wide variety of food, including sushi, seafood, and a Mongolian grill. They also highlight the reasonable prices, especially on weekdays, and the spacious seating.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-38e5-750a-ac08-6f80e899e6c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-38e5-750a-ac08-6f80e899e6c1",
        "storage_key": "property/6767906449166811/019d02d2-38e5-750a-ac08-6f80e899e6c1.webp",
        "width": 800,
        "height": 450
      },
      "poi_business_url": "http://www.harvestbuffettacoma.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3188859851387742195&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "harvest-buffet",
      "poi_latitude": "47.2237319",
      "poi_longitude": "-122.4775848",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 253-472-3888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-8b41-72ec-997e-b9d69eefbbe2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-8b41-72ec-997e-b9d69eefbbe2",
        "storage_key": "property/6767906449166811/019d02d2-8b41-72ec-997e-b9d69eefbbe2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFRqPizurkVQR86d4uCMbQSw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_8e1443e9-5bfd-4f94-b7d2-fdf6923f3ee9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "poi_name": "Farm 12 Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "B 3303 8th Ave SE, Puyallup, WA 98372, USA",
      "poi_short_description": "Farm-to-table fare, including seafood and burgers, served in an elegant setting.",
      "poi_long_description": "People say this restaurant serves delicious chicken salad sandwiches, wagyu pastrami sandwiches, and salmon bowls. They also highlight the cool atmosphere, beautiful outdoor seating, and friendly staff.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-cb26-77ec-8f1d-0dc9385f11ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-cb26-77ec-8f1d-0dc9385f11ae",
        "storage_key": "property/6767906449166811/019d02d2-cb26-77ec-8f1d-0dc9385f11ae.webp",
        "width": 1080,
        "height": 770
      },
      "poi_business_url": "http://farm12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18392565969449683685&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "farm-12-restaurant",
      "poi_latitude": "47.1853014",
      "poi_longitude": "-122.2499863",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 253-697-9486",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-8b41-72ec-997e-b9d69eefbbe2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-8b41-72ec-997e-b9d69eefbbe2",
        "storage_key": "property/6767906449166811/019d02d2-8b41-72ec-997e-b9d69eefbbe2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJg5TP2Wb7kFQR5Yr8HE2FP_8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_b53ece73-f329-4ab9-96b2-daa951062d17",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "poi_name": "Dick's Drive-In",
      "poi_type": "Restaurants",
      "poi_address": "32048 Pacific Hwy S, Federal Way, WA 98003, USA",
      "poi_short_description": "Part of an old-school chain of fast-food spots offering burgers, fries & hand-dipped shakes.",
      "poi_long_description": "Diners say this hamburger restaurant serves delicious burgers, fries, and shakes, with many praising the fresh-cut fries and creamy milkshakes. They also highlight the fast and friendly service, affordable prices, and convenient location.\n\nSome reviews mention the fries can be greasy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-cb06-7546-b556-445535160658.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-cb06-7546-b556-445535160658",
        "storage_key": "property/6767906449166811/019d02d2-cb06-7546-b556-445535160658.webp",
        "width": 1280,
        "height": 722
      },
      "poi_business_url": "https://ddir.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4590813746551303815&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dicks-drive-in",
      "poi_latitude": "47.3138041",
      "poi_longitude": "-122.3128774",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 253-681-9995",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-8b41-72ec-997e-b9d69eefbbe2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-8b41-72ec-997e-b9d69eefbbe2",
        "storage_key": "property/6767906449166811/019d02d2-8b41-72ec-997e-b9d69eefbbe2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5wZ6I9VXkFQRh64rgcfYtT8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_8d3b523a-3e55-4d26-a8ab-4a76412aa55a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "poi_name": "Matador Tacoma",
      "poi_type": "Restaurants",
      "poi_address": "721 Pacific Ave, Tacoma, WA 98402, USA",
      "poi_short_description": "Local bar chain serving classic & contemporary Mexican dishes, plus cocktails, in a stylish space.",
      "poi_long_description": "People say this Mexican restaurant serves delicious street tacos, nachos, and brussel sprouts. They also highlight the great happy hour prices and choices, and the nice atmosphere with a fire inside and covered, heated patio.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-37e4-75d8-9331-994f8849b6ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-37e4-75d8-9331-994f8849b6ce",
        "storage_key": "property/6767906449166811/019d02d2-37e4-75d8-9331-994f8849b6ce.webp",
        "width": 1126,
        "height": 751
      },
      "poi_business_url": "https://matadorrestaurants.com/locations/tacoma",
      "poi_directions_map_url": "https://maps.google.com/?cid=3823531445110426895&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "matador-tacoma",
      "poi_latitude": "47.2566835",
      "poi_longitude": "-122.4391313",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 253-627-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-8b41-72ec-997e-b9d69eefbbe2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-8b41-72ec-997e-b9d69eefbbe2",
        "storage_key": "property/6767906449166811/019d02d2-8b41-72ec-997e-b9d69eefbbe2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJQLIIKFVkFQRD81XZZfpDzU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_89bf0d72-11e5-4c39-a3d0-268fcbddc71e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "3902 S Steele St, Tacoma, WA 98409, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken sandwiches, nuggets, and lemonade. They also highlight the friendly and efficient service, and the clean dining area.\n\nSome reviews mention that orders can be incorrect.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-40df-74b4-82e8-fd9d8cf62c9b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-40df-74b4-82e8-fd9d8cf62c9b",
        "storage_key": "property/6767906449166811/019d02d2-40df-74b4-82e8-fd9d8cf62c9b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/wa/38th-steele?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=14771486606301918830&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "47.2215702",
      "poi_longitude": "-122.4689324",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 253-534-8406",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-8b41-72ec-997e-b9d69eefbbe2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-8b41-72ec-997e-b9d69eefbbe2",
        "storage_key": "property/6767906449166811/019d02d2-8b41-72ec-997e-b9d69eefbbe2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQfd-klVVkFQRbvYQRc7c_sw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_169ae012-0c83-46fb-b101-8376d0a3f680",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "poi_name": "Tacoma Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "4502 S Steele St, Tacoma, WA 98409, USA",
      "poi_short_description": "Clothing chain with trendy apparel, shoes & accessories for teen girls & young women.",
      "poi_long_description": "People say this shopping center offers a wide variety of clothing and food options, and has a free indoor play area for children. They also highlight the clean restrooms, the safe and secure environment, and the helpful staff.\n\nSome reviews mention parking can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-ccfc-745c-b105-07b131aca63c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-ccfc-745c-b105-07b131aca63c",
        "storage_key": "property/6767906449166811/019d02d2-ccfc-745c-b105-07b131aca63c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.simon.com/mall/tacoma-mall",
      "poi_directions_map_url": "https://maps.google.com/?cid=6869659206638140388&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tacoma-mall",
      "poi_latitude": "47.2160921",
      "poi_longitude": "-122.4687412",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 253-475-4565",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-8b44-73ed-931b-0ed38e8098b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-8b44-73ed-931b-0ed38e8098b0",
        "storage_key": "property/6767906449166811/019d02d2-8b44-73ed-931b-0ed38e8098b0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJEaqbEgIAkVQR5Huow6buVV8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_c2bc49e3-ecf8-4ebf-95da-f0615dc551c2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "poi_name": "South Hill Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "3500 S Meridian, Puyallup, WA 98373, USA",
      "poi_short_description": "1 million-sq.-ft. shopping mall with 120-plus stores, a multiplex & children's indoor playground.",
      "poi_long_description": "People say this shopping center has a great food court with a wide variety of options, and they like that it's clean and not too crowded. They also highlight the diverse selection of stores, including popular teen and young adult brands, and the overall pleasant atmosphere.\n\nSome reviews mention the parking can be limited, especially on weekends.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-ce66-73da-9e90-2490004f89e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-ce66-73da-9e90-2490004f89e8",
        "storage_key": "property/6767906449166811/019d02d2-ce66-73da-9e90-2490004f89e8.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "http://www.southhillmall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1097118189239010100&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "south-hill-mall",
      "poi_latitude": "47.158102",
      "poi_longitude": "-122.297266",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 253-840-2828",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-8b44-73ed-931b-0ed38e8098b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-8b44-73ed-931b-0ed38e8098b0",
        "storage_key": "property/6767906449166811/019d02d2-8b44-73ed-931b-0ed38e8098b0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJYwQzx0T8kFQRNAM2Ki6_OQ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_1612afe3-1b88-4e86-9540-540f754f1f5a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "poi_name": "Emish Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "2040 70th Ave E, Fife, WA 98424, USA",
      "poi_short_description": "Specialty store with Ukrainian groceries along with baked goods, meats and takeout dishes.",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh produce, baked goods, and European specialties, including Ukrainian dishes like borscht and perogies. They highlight the delicious food, especially the sourdough bread, pastries, and lamb gyro, and the reasonable prices. They also like the welcoming atmosphere and friendly, helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-4259-71cf-8f61-1892eddea80e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-4259-71cf-8f61-1892eddea80e",
        "storage_key": "property/6767906449166811/019d02d2-4259-71cf-8f61-1892eddea80e.webp",
        "width": 1280,
        "height": 1004
      },
      "poi_business_url": "http://emishmarket.com/?utm_source=google&utm_medium=wix_google_business_profile&utm_campaign=6291644966344206943",
      "poi_directions_map_url": "https://maps.google.com/?cid=16631521818125547868&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "emish-market",
      "poi_latitude": "47.2387655",
      "poi_longitude": "-122.3368785",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 253-262-6070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-8b3a-71ca-bafc-34a8a53b999b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-8b3a-71ca-bafc-34a8a53b999b",
        "storage_key": "property/6767906449166811/019d02d2-8b3a-71ca-bafc-34a8a53b999b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyQZUtuf5kFQRXDmI2_kIz-Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_bcba1e5c-02f7-45f4-997c-73690ea1633e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "poi_name": "H Mart",
      "poi_type": "Shopping & Retail",
      "poi_address": "31217 Pacific Hwy S, Federal Way, WA 98003, USA",
      "poi_short_description": "Large market stocking Asian groceries, including housewares, seafood and fresh produce.",
      "poi_long_description": "Shoppers say this Korean grocery store offers a wide variety of fresh produce, seafood, and Asian groceries, including kimchi, sauces, and ramen. They also highlight the friendly staff, clean environment, and convenient food court with delicious hot food options.\n\nSome reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-4863-74e9-8410-993cb418475b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-4863-74e9-8410-993cb418475b",
        "storage_key": "property/6767906449166811/019d02d2-4863-74e9-8410-993cb418475b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hmartus.com/federalway",
      "poi_directions_map_url": "https://maps.google.com/?cid=4688323470681939457&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "h-mart",
      "poi_latitude": "47.3218808",
      "poi_longitude": "-122.3152936",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 253-528-0500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-8b3a-71ca-bafc-34a8a53b999b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-8b3a-71ca-bafc-34a8a53b999b",
        "storage_key": "property/6767906449166811/019d02d2-8b3a-71ca-bafc-34a8a53b999b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo4-TAXtXkFQRAZ4fVltFEEE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_57d5504f-3c73-494f-9729-d1de9714fee1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "1913 S 72nd St, Tacoma, WA 98408, USA",
      "poi_short_description": "Employee-owned 24/7 supermarket chain with discounted groceries & bulk foods, plus a deli & bakery.",
      "poi_long_description": "People say this supermarket offers a wide selection of groceries, including bulk foods and produce. They also highlight the low prices and the friendly staff.\n\nSome reviews mention the store can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-49e5-71fe-a69f-c53cc39cf3cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-49e5-71fe-a69f-c53cc39cf3cc",
        "storage_key": "property/6767906449166811/019d02d2-49e5-71fe-a69f-c53cc39cf3cc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10993939095152252900&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "47.195192",
      "poi_longitude": "-122.459911",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 253-830-3005",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-8b3a-71ca-bafc-34a8a53b999b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-8b3a-71ca-bafc-34a8a53b999b",
        "storage_key": "property/6767906449166811/019d02d2-8b3a-71ca-bafc-34a8a53b999b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjbWeSjsAkVQR5FfU0FtRkpg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_9d57b3e9-76d0-434f-aa0a-cc6eabb9dea1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "poi_name": "University of Washington Tacoma",
      "poi_type": "Education",
      "poi_address": "1900 Commerce St, Tacoma, WA 98402, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-4afe-75c9-b3bf-7cc479f8b262.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-4afe-75c9-b3bf-7cc479f8b262",
        "storage_key": "property/6767906449166811/019d02d2-4afe-75c9-b3bf-7cc479f8b262.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.tacoma.uw.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8015147170715330239&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-of-washington-tacoma",
      "poi_latitude": "47.2454407",
      "poi_longitude": "-122.4385162",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 253-692-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-8b3f-760f-8e89-b7e00f63e742.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-8b3f-760f-8e89-b7e00f63e742",
        "storage_key": "property/6767906449166811/019d02d2-8b3f-760f-8e89-b7e00f63e742.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJWzChLXdVkFQRv-b2vOKFO28",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_d586abd8-5d04-43d8-a762-126bcf2e4bcc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "poi_name": "Puyallup Public Library",
      "poi_type": "Education",
      "poi_address": "324 S Meridian, Puyallup, WA 98371, USA",
      "poi_short_description": "Welcoming library featuring events for kids, books, computers and a friendly staff.",
      "poi_long_description": "People say this public library offers a wide variety of media, including books, manga, magazines, comics, movies, and board games, and has a designated play area for kids. They highlight the library is large, clean, and organized, and has a nice teen area and a park outside. They also like the helpful, professional, and kind staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-4df7-73b8-84f1-d103b91a399a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-4df7-73b8-84f1-d103b91a399a",
        "storage_key": "property/6767906449166811/019d02d2-4df7-73b8-84f1-d103b91a399a.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "http://www.puyalluplibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12452978426720017904&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "puyallup-public-library",
      "poi_latitude": "47.1895629",
      "poi_longitude": "-122.2954362",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 253-841-5454",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-8b3f-760f-8e89-b7e00f63e742.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-8b3f-760f-8e89-b7e00f63e742",
        "storage_key": "property/6767906449166811/019d02d2-8b3f-760f-8e89-b7e00f63e742.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJwz4I56n-kFQR8N0_gObd0aw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_1355c4dc-b180-4bac-a33c-8bc254305e3d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "poi_name": "Wild Waves Theme and Water Park",
      "poi_type": "Entertainment",
      "poi_address": "36201 Enchanted Pkwy S, Federal Way, WA 98003, USA",
      "poi_short_description": "Theme park with roller coasters & kid-friendly rides, plus a water area with pools & slides.",
      "poi_long_description": "People say this amusement park offers a variety of water rides, roller coasters, and kiddie rides, and that the season pass provides good value.\n\nOther reviews mention the lines can be long and some rides can be closed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-d439-719f-84f8-4d25c9f50c09.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-d439-719f-84f8-4d25c9f50c09",
        "storage_key": "property/6767906449166811/019d02d2-d439-719f-84f8-4d25c9f50c09.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.wildwaves.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=120734302365377506&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wild-waves-theme-and-water-park",
      "poi_latitude": "47.2731529",
      "poi_longitude": "-122.3126059",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 253-661-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-9113-769e-97ba-cfe574f24cd1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-9113-769e-97ba-cfe574f24cd1",
        "storage_key": "property/6767906449166811/019d02d2-9113-769e-97ba-cfe574f24cd1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaVjyU9RXkFQR4mOxVDXvrAE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_b6afd6dd-50cb-481f-8b40-53132a79ebf2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "poi_name": "Museum of Glass",
      "poi_type": "Entertainment",
      "poi_address": "1801 Dock St, Tacoma, WA 98402, USA",
      "poi_short_description": "Diverse indoor & outdoor glass-art exhibits plus a cone-shaped studio with working artists.",
      "poi_long_description": "People say this art museum offers beautiful glasswork and live glass blowing demonstrations. They highlight the unique and creative exhibits, including pieces inspired by children's drawings, and the opportunity to watch artists at work in the hot shop. They also like the affordable tickets, easy parking, and the overall enjoyable experience for people who like glass art.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-d42b-7139-9a8d-413c140d5d7d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-d42b-7139-9a8d-413c140d5d7d",
        "storage_key": "property/6767906449166811/019d02d2-d42b-7139-9a8d-413c140d5d7d.webp",
        "width": 1280,
        "height": 919
      },
      "poi_business_url": "https://www.museumofglass.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12420455278076938078&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "museum-of-glass",
      "poi_latitude": "47.24550079999999",
      "poi_longitude": "-122.4340189",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 253-284-4750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-9112-734b-8b9a-cbdf4f40aa69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-9112-734b-8b9a-cbdf4f40aa69",
        "storage_key": "property/6767906449166811/019d02d2-9112-734b-8b9a-cbdf4f40aa69.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJGTMDr3dVkFQRXsdm3kRSXqw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_cd077e55-5dc9-400b-af03-a86833403bf4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "poi_name": "LeMay - America’s Car Museum",
      "poi_type": "Entertainment",
      "poi_address": "2702 E D St, Tacoma, WA 98421, USA",
      "poi_short_description": "4-story museum on an 8-acre campus displays cars, trucks & motorcycles in historic & tech exhibits.",
      "poi_long_description": "Visitors say this museum features an impressive collection of classic cars, including muscle cars and vintage sedans, with rotating exhibits like the recent Japanese car showcase. They also highlight the friendly and knowledgeable staff, kid-friendly activities like slot car racing, and the convenient free parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-50f2-7118-88df-056a43ee3f08.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-50f2-7118-88df-056a43ee3f08",
        "storage_key": "property/6767906449166811/019d02d2-50f2-7118-88df-056a43ee3f08.webp",
        "width": 729,
        "height": 521
      },
      "poi_business_url": "http://www.americascarmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17839745701636681105&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lemay---americas-car-museum",
      "poi_latitude": "47.2357021",
      "poi_longitude": "-122.4303289",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 253-779-8490",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-9112-734b-8b9a-cbdf4f40aa69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-9112-734b-8b9a-cbdf4f40aa69",
        "storage_key": "property/6767906449166811/019d02d2-9112-734b-8b9a-cbdf4f40aa69.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJWR-QTHxVkFQRkS1bVTKCk_c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_dc7d8e87-76e0-4289-82fe-5435fc4a6670",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "poi_name": "Children's Museum of Tacoma",
      "poi_type": "Entertainment",
      "poi_address": "1501 Pacific Ave, Tacoma, WA 98402, USA",
      "poi_short_description": "Museum with 5 playscapes offering hands-on exploration designed to entertain & educate children.",
      "poi_long_description": "Visitors say this children's museum offers a variety of hands-on activities, including a water play area, climbing structures, and an art room, and they appreciate the suggested donation admission fee. They also highlight the friendly and helpful staff, and the clean and well-maintained facility.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-526a-76be-a93a-0f01dbccdf32.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-526a-76be-a93a-0f01dbccdf32",
        "storage_key": "property/6767906449166811/019d02d2-526a-76be-a93a-0f01dbccdf32.webp",
        "width": 1263,
        "height": 710
      },
      "poi_business_url": "http://greentrike.org/childrens-museum-of-tacoma",
      "poi_directions_map_url": "https://maps.google.com/?cid=1983464320316777643&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "childrens-museum-of-tacoma",
      "poi_latitude": "47.2489636",
      "poi_longitude": "-122.4373771",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 253-627-6031",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-9112-734b-8b9a-cbdf4f40aa69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-9112-734b-8b9a-cbdf4f40aa69",
        "storage_key": "property/6767906449166811/019d02d2-9112-734b-8b9a-cbdf4f40aa69.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4cHieaBVkFQRq6QkXUquhhs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_07f93308-9e91-49e2-866c-53c4a1b051c9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "poi_name": "Tacoma Art Museum",
      "poi_type": "Entertainment",
      "poi_address": "1701 Pacific Ave, Tacoma, WA 98402, USA",
      "poi_short_description": "Exhibits feature Dale Chihuly glass works, European Impressionism, Japanese prints & American art.",
      "poi_long_description": "People say this art museum offers a variety of exhibits, including local artists and a Chihuly glass exhibit. They highlight the beautiful building, accessible parking, and reasonable prices. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-5455-768a-ad3a-3218f8d23e70.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-5455-768a-ad3a-3218f8d23e70",
        "storage_key": "property/6767906449166811/019d02d2-5455-768a-ad3a-3218f8d23e70.webp",
        "width": 1280,
        "height": 680
      },
      "poi_business_url": "http://www.tacomaartmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3943333449812358662&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tacoma-art-museum",
      "poi_latitude": "47.2473997",
      "poi_longitude": "-122.4368025",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 253-272-4258",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-9112-734b-8b9a-cbdf4f40aa69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-9112-734b-8b9a-cbdf4f40aa69",
        "storage_key": "property/6767906449166811/019d02d2-9112-734b-8b9a-cbdf4f40aa69.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJswi_f3ZVkFQRBjb7QuGIuTY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_b40b995a-053f-4daf-b74e-039e5a66442a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "35009 Enchanted Pkwy S, Federal Way, WA 98003, USA",
      "poi_short_description": "Spacious, clean athletic facility featuring a wide variety of equipment and classes, plus a pool.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-599a-73da-b467-dd17551bb72e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-599a-73da-b467-dd17551bb72e",
        "storage_key": "property/6767906449166811/019d02d2-599a-73da-b467-dd17551bb72e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=325&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=18330114516273239084&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "47.2877945",
      "poi_longitude": "-122.315461",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 253-838-5900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-9113-769e-97ba-cfe574f24cd1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-9113-769e-97ba-cfe574f24cd1",
        "storage_key": "property/6767906449166811/019d02d2-9113-769e-97ba-cfe574f24cd1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe4MOHcZXkFQRLJSyEgmmYf4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_f8502e02-0b6c-498c-912a-ab356eac68eb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "111 S 38th St, Tacoma, WA 98418, USA",
      "poi_short_description": "Membership-only chain fitness center offering cardio and weight equipment, an indoor pool, and 24/7 access.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-5b78-7137-9b6d-f7a434827470.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-5b78-7137-9b6d-f7a434827470",
        "storage_key": "property/6767906449166811/019d02d2-5b78-7137-9b6d-f7a434827470.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/tacoma-wa/tacoma-super-sport?Adb_id=GGL_LOC_ACQ_CDP",
      "poi_directions_map_url": "https://maps.google.com/?cid=414306649313173586&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "47.2241978",
      "poi_longitude": "-122.4321077",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 253-240-3483",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-9113-769e-97ba-cfe574f24cd1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-9113-769e-97ba-cfe574f24cd1",
        "storage_key": "property/6767906449166811/019d02d2-9113-769e-97ba-cfe574f24cd1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLWkr0I3_kFQRUuBk1LPpvwU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_cb437a50-14d1-4366-b250-10b5f06704b4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "poi_name": "Union Salon",
      "poi_type": "Health and Wellness",
      "poi_address": "708 Opera Aly, Tacoma, WA 98402, USA",
      "poi_short_description": "Relaxed, upscale salon for cuts, coloring and styling services, plus hair-care products.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://uniontacoma.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3572464139224888116&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "union-salon",
      "poi_latitude": "47.25727939999999",
      "poi_longitude": "-122.4418586",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 253-327-1484",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-9113-769e-97ba-cfe574f24cd1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-9113-769e-97ba-cfe574f24cd1",
        "storage_key": "property/6767906449166811/019d02d2-9113-769e-97ba-cfe574f24cd1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2Y_DM6dVkFQRNDNS9zTxkzE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_9393aa1a-6ac3-49b0-96b7-dc5cef81bcdf",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "poi_name": "University YMCA Student Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1710 Market St, Tacoma, WA 98402, USA",
      "poi_short_description": "Branch of the Family YMCA chain located inside the University Y Student Center in New Tacoma.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-dad4-7759-9064-a375996ae6f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-dad4-7759-9064-a375996ae6f8",
        "storage_key": "property/6767906449166811/019d02d2-dad4-7759-9064-a375996ae6f8.webp",
        "width": 721,
        "height": 1280
      },
      "poi_business_url": "https://www.ymcapkc.org/locations/university-ymca-student-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=569589627320068484&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-ymca-student-center",
      "poi_latitude": "47.2463039",
      "poi_longitude": "-122.4404075",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 253-272-9622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-9113-769e-97ba-cfe574f24cd1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-9113-769e-97ba-cfe574f24cd1",
        "storage_key": "property/6767906449166811/019d02d2-9113-769e-97ba-cfe574f24cd1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN44xq3ZVkFQRhOkojL-W5wc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_de030185-7620-4386-9a84-65f1049ea256",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "poi_name": "UFC FIT Puyallup",
      "poi_type": "Health and Wellness",
      "poi_address": "307 37th Ave SE, Puyallup, WA 98374, USA",
      "poi_short_description": "MMA-inspired fitness facility featuring a pool, boxing and other group classes, as well as personal training services.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including free weights, machines, turf, and recovery tools, as well as amenities like a pool, sauna, and basketball court. They also highlight the spacious and clean facility, the friendly and helpful staff, and the motivating and welcoming atmosphere.\n\nOther reviews mention the cancellation process can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-dbcb-70df-823d-9df0af840882.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-dbcb-70df-823d-9df0af840882",
        "storage_key": "property/6767906449166811/019d02d2-dbcb-70df-823d-9df0af840882.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.ufcgym.com/locations/puyallup",
      "poi_directions_map_url": "https://maps.google.com/?cid=7779713240961042868&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ufc-fit-puyallup",
      "poi_latitude": "47.1575111",
      "poi_longitude": "-122.2887034",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 253-432-8322",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-9113-769e-97ba-cfe574f24cd1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-9113-769e-97ba-cfe574f24cd1",
        "storage_key": "property/6767906449166811/019d02d2-9113-769e-97ba-cfe574f24cd1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuauP4zX9kFQRtMniVfkX92s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_5711b1cc-7f19-4fce-a4ad-a0b24f8d95e0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2800 Milton Way, Milton, WA 98354, USA",
      "poi_short_description": "Chain fitness center with tanning beds, showers, and modern equipment.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including weights, machines, and additional services like infrared treatments and hydro massages. They highlight the clean facilities, well-maintained equipment, and convenient amenities such as showers and a large parking lot. They also like the friendly, welcoming, and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-d7f2-753a-91f8-956846894e0a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-d7f2-753a-91f8-956846894e0a",
        "storage_key": "property/6767906449166811/019d02d2-d7f2-753a-91f8-956846894e0a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/milton-wa?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=1125001896294757161&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "47.2510152",
      "poi_longitude": "-122.2957753",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 253-292-3775",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-9113-769e-97ba-cfe574f24cd1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-9113-769e-97ba-cfe574f24cd1",
        "storage_key": "property/6767906449166811/019d02d2-9113-769e-97ba-cfe574f24cd1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwb7hBxn5kFQRKTNKoEPPnA8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d2da7ec0-0dc1-44d7-bf1d-3e5ac2f4eb6f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "poi_name": "MultiCare Tacoma General Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "315 M.L.K. Jr Way, Tacoma, WA 98405, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-685c-77ef-8f23-856f82c5abed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-685c-77ef-8f23-856f82c5abed",
        "storage_key": "property/6767906449166811/019d02d2-685c-77ef-8f23-856f82c5abed.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.multicare.org/location/tacoma-general-hospital/?utm_source=pg-google&utm_medium=organic&utm_campaign=pg-listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=2281678395220750182&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "multicare-tacoma-general-hospital",
      "poi_latitude": "47.2595367",
      "poi_longitude": "-122.4529018",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 253-403-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-9115-778e-8246-f3f4302f2b21.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-9115-778e-8246-f3f4302f2b21",
        "storage_key": "property/6767906449166811/019d02d2-9115-778e-8246-f3f4302f2b21.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJYwARMQZVkFQRZu_QXmkmqh8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_250d4f09-9084-496a-9dfb-655f27a4cb4e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "poi_name": "St. Joseph Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1717 S J St, Tacoma, WA 98405, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-dd1d-71f9-9c3f-a4a144658dfd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-dd1d-71f9-9c3f-a4a144658dfd",
        "storage_key": "property/6767906449166811/019d02d2-dd1d-71f9-9c3f-a4a144658dfd.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.vmfh.org/our-hospitals/st-joseph-medical-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=1086247563015510942&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "st-joseph-medical-center",
      "poi_latitude": "47.24549409999999",
      "poi_longitude": "-122.4479997",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 253-426-4101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-9115-778e-8246-f3f4302f2b21.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-9115-778e-8246-f3f4302f2b21",
        "storage_key": "property/6767906449166811/019d02d2-9115-778e-8246-f3f4302f2b21.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8dbfYXJVkFQRnlusQ2cgEw8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_7bd2cf74-145f-4244-8431-608787e7a7a3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "poi_name": "Dash Point State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5700 SW Dash Point Rd, Federal Way, WA 98023, USA",
      "poi_short_description": "Park offering 400 acres on Puget Sound for swimming, camping, hiking, biking & hand-launched boats.",
      "poi_long_description": "People say this state park offers a beautiful beach, hiking trails, and a campground. They highlight the tranquil atmosphere, the opportunity to see wildlife, and the convenient access to amenities. They also like the ample parking and picnic areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-e0b2-759d-96e6-d44db811c682.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-e0b2-759d-96e6-d44db811c682",
        "storage_key": "property/6767906449166811/019d02d2-e0b2-759d-96e6-d44db811c682.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://parks.state.wa.us/496/Dash-Point",
      "poi_directions_map_url": "https://maps.google.com/?cid=13678784741833558784&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dash-point-state-park",
      "poi_latitude": "47.3131856",
      "poi_longitude": "-122.4049297",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 253-661-4955",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-9179-753c-bda4-6806091ae975.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-9179-753c-bda4-6806091ae975",
        "storage_key": "property/6767906449166811/019d02d2-9179-753c-bda4-6806091ae975.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJmwreYMdWkFQRAMsF2D_O1L0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_cc089f94-e845-4251-8cb9-8ed2d290fa5c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "poi_name": "Wright Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "501 S I St, Tacoma, WA 98405, USA",
      "poi_short_description": "Greenspace with a vast collection of trees, plus a trail, playgrounds, sport courts & picnic areas.",
      "poi_long_description": "People say this park offers a splash pad, playground, walking paths, a duck pond, and a conservatory. They highlight the beautiful trees, the relaxing atmosphere, and the well-maintained facilities. They also like the free activities and lunch for children during the summer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-e159-765e-85d0-899017eefada.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-e159-765e-85d0-899017eefada",
        "storage_key": "property/6767906449166811/019d02d2-e159-765e-85d0-899017eefada.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.metroparkstacoma.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18017825162376901426&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wright-park",
      "poi_latitude": "47.2594789",
      "poi_longitude": "-122.4489414",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 253-305-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-9179-753c-bda4-6806091ae975.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-9179-753c-bda4-6806091ae975",
        "storage_key": "property/6767906449166811/019d02d2-9179-753c-bda4-6806091ae975.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJocxN_wdVkFQRMvORzIUsDPo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_651ef7b5-cfed-49cc-9e81-ae04cebf1941",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "poi_name": "Wapato Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6500 S Sheridan Ave, Tacoma, WA 98408, USA",
      "poi_short_description": "Urban park featuring a woodland area, a lake, walking trail & dog park, plus a historic pergola.",
      "poi_long_description": "People say this park offers a lake, walking trails, picnic areas, playgrounds, and dog parks, including an off-leash area. They highlight the peaceful and tranquil vibe, and the well-maintained grounds with plenty of green spaces. They also like the diverse activities, such as fishing and feeding ducks, and the family-friendly atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-6ebd-73bb-86bf-b909ec28e976.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-6ebd-73bb-86bf-b909ec28e976",
        "storage_key": "property/6767906449166811/019d02d2-6ebd-73bb-86bf-b909ec28e976.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.metroparkstacoma.org/wapato-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15744537620839301556&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wapato-park",
      "poi_latitude": "47.1954541",
      "poi_longitude": "-122.4538614",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 5 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 253-305-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-9179-753c-bda4-6806091ae975.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-9179-753c-bda4-6806091ae975",
        "storage_key": "property/6767906449166811/019d02d2-9179-753c-bda4-6806091ae975.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJi1A9_yQAkVQRtIHmSozVf9o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_aece30e9-1d72-48d1-8497-a4e191ffb7da",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "poi_name": "Celebration Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1095 South 324th St, Federal Way, WA 98003, USA",
      "poi_short_description": "Large public park with lighted baseball & soccer fields, plus a playground, picnic areas & trails.",
      "poi_long_description": "People say this city park offers multiple athletic fields, a playground, and hiking trails. They also highlight the park's connection to the BPA trail, ample parking, and clean, well-maintained facilities.\n\nOther reviews mention the playground can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-e444-7748-ba13-2b1e2ed04699.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-e444-7748-ba13-2b1e2ed04699",
        "storage_key": "property/6767906449166811/019d02d2-e444-7748-ba13-2b1e2ed04699.webp",
        "width": 1280,
        "height": 994
      },
      "poi_business_url": "https://www.federalwaywa.gov/page/our-parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=6934449869024769639&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "celebration-park",
      "poi_latitude": "47.3077102",
      "poi_longitude": "-122.3201244",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 253-835-6960",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-9179-753c-bda4-6806091ae975.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-9179-753c-bda4-6806091ae975",
        "storage_key": "property/6767906449166811/019d02d2-9179-753c-bda4-6806091ae975.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJFRjHYZ9XkFQRZ7b5Y2odPGA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_452659dc-376d-44bc-855c-79ca949d7da5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "poi_name": "Bradley Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "531 31st Ave SE, Puyallup, WA 98374, USA",
      "poi_short_description": "59-acre park featuring a lake, fishing, trails, a playground, picnic areas, baseball & restrooms.",
      "poi_long_description": "People say this city park offers a paved trail around a lake, a large playground, and fishing opportunities. They highlight the beautiful scenery, the abundance of wildlife, and the availability of picnic areas and restrooms. They also like the well-maintained trails and the family-friendly atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-71e6-744a-bc31-9adc2d81ea3b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-71e6-744a-bc31-9adc2d81ea3b",
        "storage_key": "property/6767906449166811/019d02d2-71e6-744a-bc31-9adc2d81ea3b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cityofpuyallup.org/Facilities/Facility/Details/Bradley-Lake-Park-2",
      "poi_directions_map_url": "https://maps.google.com/?cid=1336997023589048424&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bradley-lake-park",
      "poi_latitude": "47.16164879999999",
      "poi_longitude": "-122.2854336",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 253-841-5457",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-9179-753c-bda4-6806091ae975.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-9179-753c-bda4-6806091ae975",
        "storage_key": "property/6767906449166811/019d02d2-9179-753c-bda4-6806091ae975.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJdZH9H2j8kFQRaKDHkLX3jRI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_964f7794-d5ef-44d7-bcd9-a59745914cb4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "poi_name": "Tacoma Dome",
      "poi_type": "Transportation & Transit",
      "poi_address": "422 E 25th St, Tacoma, WA 98421, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this train station offers access to Amtrak Cascades and Sounder Commuter Rail. They also highlight the station is clean, spacious, and well-lit, with ample seating and restrooms.\n\nOther reviews mention the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-e78e-73af-a562-7b904abce3cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-e78e-73af-a562-7b904abce3cb",
        "storage_key": "property/6767906449166811/019d02d2-e78e-73af-a562-7b904abce3cb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=TAC",
      "poi_directions_map_url": "https://maps.google.com/?cid=11981741027217255491&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tacoma-dome",
      "poi_latitude": "47.2396052",
      "poi_longitude": "-122.4281656",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-960f-754e-81b6-df1bea058d05.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-960f-754e-81b6-df1bea058d05",
        "storage_key": "property/6767906449166811/019d02d2-960f-754e-81b6-df1bea058d05.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJcfRhf4FVkFQRQywCdvuxR6Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_21dda11e-96e4-4005-8192-0cd2e9e775d5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "poi_name": "Puyallup",
      "poi_type": "Transportation & Transit",
      "poi_address": "Puyallup, WA 98371, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-e760-77f9-a9a1-417895abb6e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-e760-77f9-a9a1-417895abb6e3",
        "storage_key": "property/6767906449166811/019d02d2-e760-77f9-a9a1-417895abb6e3.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.soundtransit.org/Rider-Guide/Puyallup-Station",
      "poi_directions_map_url": "https://maps.google.com/?cid=6932385689825660565&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "puyallup",
      "poi_latitude": "47.1926175",
      "poi_longitude": "-122.295561",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-960f-754e-81b6-df1bea058d05.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-960f-754e-81b6-df1bea058d05",
        "storage_key": "property/6767906449166811/019d02d2-960f-754e-81b6-df1bea058d05.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJrWSlxKv-kFQRlU4POA7INGA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_88672399-0cea-4fb0-a2da-e3bb4ad939ec",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "poi_name": "Sumner",
      "poi_type": "Transportation & Transit",
      "poi_address": "810 Maple St., Sumner, WA 98390, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.soundtransit.org/Rider-Guide/Sumner-Station",
      "poi_directions_map_url": "https://maps.google.com/?cid=15340170366867992869&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sumner",
      "poi_latitude": "47.2016551",
      "poi_longitude": "-122.2445703",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 800-201-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-960f-754e-81b6-df1bea058d05.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-960f-754e-81b6-df1bea058d05",
        "storage_key": "property/6767906449166811/019d02d2-960f-754e-81b6-df1bea058d05.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJrTveu9n7kFQRJfEjR6w749Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_156addff-b19c-496e-8086-87ddb5bf62e4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "poi_name": "Union Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Tacoma, WA 98402, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-e761-71e6-a7d2-a56319f85ee1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-e761-71e6-a7d2-a56319f85ee1",
        "storage_key": "property/6767906449166811/019d02d2-e761-71e6-a7d2-a56319f85ee1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.soundtransit.org/Rider-Guide/Union-Station",
      "poi_directions_map_url": "https://maps.google.com/?cid=3939718128236109500&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "union-station",
      "poi_latitude": "47.24487",
      "poi_longitude": "-122.43662",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-9113-769e-97ba-cfe574f24cd1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-9113-769e-97ba-cfe574f24cd1",
        "storage_key": "property/6767906449166811/019d02d2-9113-769e-97ba-cfe574f24cd1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2wDnIHdVkFQRvB6unMOwrDY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_acf98906-abc3-4c48-a1e8-77d95bb5e0e9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "poi_name": "DaVita Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3201 S 323rd St, Federal Way, WA 98001, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://davita.com/about/contact-us",
      "poi_directions_map_url": "https://maps.google.com/?cid=1368784550882395259&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "davita-corporate-office",
      "poi_latitude": "47.3113754",
      "poi_longitude": "-122.2929799",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 253-733-4602",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-9113-769e-97ba-cfe574f24cd1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-9113-769e-97ba-cfe574f24cd1",
        "storage_key": "property/6767906449166811/019d02d2-9113-769e-97ba-cfe574f24cd1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy6Zz9oZXkFQRe0RjAUzm_hI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_81e964cb-f02b-43ab-a9d6-fa31bbbab010",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "poi_name": "REI Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1700 45th St E, Sumner, WA 98352, USA",
      "poi_short_description": "Retail chain carrying gear, apparel & footwear for a wide range of outdoor & fitness activities.",
      "poi_long_description": "Retail chain carrying gear, apparel & footwear for a wide range of outdoor & fitness activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-ea73-7554-86c7-69122ed3a60f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-ea73-7554-86c7-69122ed3a60f",
        "storage_key": "property/6767906449166811/019d02d2-ea73-7554-86c7-69122ed3a60f.webp",
        "width": 1280,
        "height": 678
      },
      "poi_business_url": "https://www.rei.com/?y_source=1_MTQ1MzQ2OC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=11430655182386199918&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rei-headquarters",
      "poi_latitude": "47.2161801",
      "poi_longitude": "-122.231871",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 425-300-3003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-9113-769e-97ba-cfe574f24cd1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-9113-769e-97ba-cfe574f24cd1",
        "storage_key": "property/6767906449166811/019d02d2-9113-769e-97ba-cfe574f24cd1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu86iMfVbkFQRbn0bgFPYoZ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_e2e94546-f5ea-488a-8c7d-6841b6c86b0c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "poi_name": "Federal Way City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "33325 8th Ave S, Federal Way, WA 98003, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-80b2-776d-a6e3-3325220f7b71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-80b2-776d-a6e3-3325220f7b71",
        "storage_key": "property/6767906449166811/019d02d2-80b2-776d-a6e3-3325220f7b71.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cityoffederalway.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12254893830259000528&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "federal-way-city-hall",
      "poi_latitude": "47.3040068",
      "poi_longitude": "-122.32649",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 253-835-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-960e-723a-9860-81eaf9727a78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-960e-723a-9860-81eaf9727a78",
        "storage_key": "property/6767906449166811/019d02d2-960e-723a-9860-81eaf9727a78.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWYCoHKRXkFQR0MS2aAIhEqo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_135cc1db-f7d8-4f36-9b7a-f989e0ae608c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "poi_name": "Superior Tank Lines",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1112 Center St, Tacoma, WA 98409, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-ed38-775c-bc1a-841aafbcc021.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-ed38-775c-bc1a-841aafbcc021",
        "storage_key": "property/6767906449166811/019d02d2-ed38-775c-bc1a-841aafbcc021.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://superiortanklines.com/careers/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14826495922307135905&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "superior-tank-lines",
      "poi_latitude": "47.2333958",
      "poi_longitude": "-122.4489631",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 909-430-0855",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-9113-769e-97ba-cfe574f24cd1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-9113-769e-97ba-cfe574f24cd1",
        "storage_key": "property/6767906449166811/019d02d2-9113-769e-97ba-cfe574f24cd1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZbqKMmdVkFQRofnkuHxLws0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_7e9ff4c5-9619-4279-b4f6-7686e2854408",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "poi_name": "City of Puyallup",
      "poi_type": "Major Employers & Offices",
      "poi_address": "333 S Meridian, Puyallup, WA 98371, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.cityofpuyallup.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1061274198908632755&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "city-of-puyallup",
      "poi_latitude": "47.1893812",
      "poi_longitude": "-122.2934216",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 253-841-4321",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-960e-723a-9860-81eaf9727a78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-960e-723a-9860-81eaf9727a78",
        "storage_key": "property/6767906449166811/019d02d2-960e-723a-9860-81eaf9727a78.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7caABgL8kFQRs34800Jnug4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_64234141-a208-4481-940d-58e07b647343",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "poi_name": "Fife High School",
      "poi_type": "Education",
      "poi_address": "5616 20th St E, Fife, WA 98424, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/01a08c4b-8156-71e9-be07-8b1295f8d56d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a08c4b-8156-71e9-be07-8b1295f8d56d",
        "storage_key": "property/6767906449166811/01a08c4b-8156-71e9-be07-8b1295f8d56d.webp",
        "width": 720,
        "height": 313
      },
      "poi_business_url": "http://fhs.fifeschools.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14254095055596171987&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "fife-high-school",
      "poi_latitude": "47.23839539999999",
      "poi_longitude": "-122.3531471",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-517-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-8b3f-760f-8e89-b7e00f63e742.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-8b3f-760f-8e89-b7e00f63e742",
        "storage_key": "property/6767906449166811/019d02d2-8b3f-760f-8e89-b7e00f63e742.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKS_7MEr_kFQR0zJ2f-630MU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_b28d6e1e-e39f-4afa-b41a-286a07fdeb64",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "poi_name": "Fife Elementary School",
      "poi_type": "Education",
      "poi_address": "5804 20th St E, Fife, WA 98424, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/01a08c4b-8157-735f-a45e-5b26bed62fd8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a08c4b-8157-735f-a45e-5b26bed62fd8",
        "storage_key": "property/6767906449166811/01a08c4b-8157-735f-a45e-5b26bed62fd8.webp",
        "width": 718,
        "height": 404
      },
      "poi_business_url": "http://fes.fifeschools.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4523700542675697288&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "fife-elementary-school",
      "poi_latitude": "47.23737329999999",
      "poi_longitude": "-122.3506164",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-517-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-8b3f-760f-8e89-b7e00f63e742.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-8b3f-760f-8e89-b7e00f63e742",
        "storage_key": "property/6767906449166811/019d02d2-8b3f-760f-8e89-b7e00f63e742.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJgQgS-7z_kFQRiD5tDK1pxz4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_5e7dfb8a-8955-4102-b23c-a72b641ff8fc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "poi_name": "Columbia Junior High School",
      "poi_type": "Education",
      "poi_address": "2901 54th Ave E, Fife, WA 98424, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/01a08c4b-81ba-727a-afb2-024bbd4d9d82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a08c4b-81ba-727a-afb2-024bbd4d9d82",
        "storage_key": "property/6767906449166811/01a08c4b-81ba-727a-afb2-024bbd4d9d82.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://cjh.fifeschools.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17824050626657046128&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "columbia-junior-high-school",
      "poi_latitude": "47.2309272",
      "poi_longitude": "-122.3556053",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-517-1600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-8b3f-760f-8e89-b7e00f63e742.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-8b3f-760f-8e89-b7e00f63e742",
        "storage_key": "property/6767906449166811/019d02d2-8b3f-760f-8e89-b7e00f63e742.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJG-8GYDf_kFQRcM547Ju_W_c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    }
  ],
  "office_hours": [
    {
      "id": "custom_7c3cf5df-ea97-4686-9c5b-a6fdef604617",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_607b96a8-839e-423f-87bc-23edbeb033f9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_e62f0382-8007-4cb6-84de-b5c96c541707",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_29c00a3f-1072-4c11-844d-17d7c05dc20b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_e8d891be-50dd-4669-a720-998d43076039",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_6b14277a-1f5e-46b1-a429-43f02bc425af",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_23ff5a32-2fc9-41a8-860d-ee067380ebef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "rating": "5.0",
      "name": "Sean Ulrich",
      "text": "So far, so good.  Move in Washington easy and hassle free, Tracy addressed all the concerns that I had.",
      "date": "2025-06-16",
      "title": ""
    },
    {
      "id": "custom_9c13d018-ebaa-4353-9e4a-91d41aa77fa5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "rating": "5.0",
      "name": "Sukhjot Mann",
      "text": "Astoria Apartments is a beautiful home area. Their agent, Tracy, was very kind and helpful. She went though all the information and paperwork with us thoroughly and was really flexible.",
      "date": "2025-08-29",
      "title": ""
    },
    {
      "id": "custom_133fb368-5018-45ef-b578-557cbff868c4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "rating": "5",
      "name": "Amber Anastasia Valadez",
      "text": "Enjoyable place to live, the manager interacts with us tenants in a fun and exciting way. She always creates fun recreational events for all of us tenants to join and interact with eachother. My favorite peaceful place on the site is the useful gym.",
      "date": "2026-09-02",
      "title": "false"
    },
    {
      "id": "custom_8041e4a9-295c-4fb6-a5da-6664dd48c3de",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "rating": "5",
      "name": " Erika Washington",
      "text": "When I first moved here 2 months ago Alexandria the apartment manager was very nice and attentive. She answered all the questions I needed answered. Whenever I put in a work order it doesn’t take long for JT to come out fix what I need fixed and I appreciate that from him.",
      "date": "2026-09-03",
      "title": "false"
    },
    {
      "id": "custom_26b7532f-4cab-4901-a478-fe3f21c77eb7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "rating": "4",
      "name": " Emily Miller",
      "text": "Hi! I have lived here in Astoria apartments for roughly two years. I have lived downstairs and upstairs! I do like how the apartments are pretty spacious. The maintenance is very helpful. The grounds are kept nicely with plants and flowers mostly green grass and kept up every week. There is a small laundry room. I have a laundry washer and dryer unit in my apartment. The kids area is very small needs to be updated but definitely nice to have. There's an area with umbrellas a glass fire pit and barbecues to use for our community. There is a dog washroom which is really nice to have. There is a dog park that's gated. What I appreciate the most is how quiet it is here! It's a nice community apartment complex!",
      "date": "2026-09-01",
      "title": "false"
    },
    {
      "id": "custom_6cf6fa0e-6ae0-43ae-a6ab-1f8c0a1fd797",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "rating": "5",
      "name": "Laci Gain",
      "text": "The staff here is so friendly and accommodating!! Move in was a breeze with them and they were very flexible which made everything so smooth! JT, the maintenance guy is awesome, I get to see and chat with him practically every morning while he’s picking up the lot. Have loved living here so far",
      "date": "2026-09-03",
      "title": "false"
    },
    {
      "id": "custom_27117786-eb36-4ba6-a7a7-db419f9635db",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "rating": "5",
      "name": "Heather S",
      "text": "I’ve had a wonderful experience with Astoria Apartments so far! Alyx, the Property Manager, has been absolutely fantastic throughout the entire process. She was prompt in responding to my application, quickly scheduled my tour, and has been present and helpful every step of the way.\n\nThe facilities are clean, updated, and very well maintained, thanks in large part to JT and the work he puts into the property. While I haven’t officially moved in full-time yet, Alyx and the team have been great about addressing any questions or issues I’ve had and making sure I feel taken care of.\n\nI also really appreciate the effort Alyx puts into creating a sense of community through resident events. The first one I attended was “Barks & Bubbles,” and it was such a fun way to meet other residents and feel welcomed.\n\nOverall, my experience with Astoria has been excellent. Alyx’s communication, responsiveness, and genuine care for the residents really stand out. I’m excited to officially call Astoria home!",
      "date": "2026-09-02",
      "title": "false"
    },
    {
      "id": "custom_e5399a6d-b695-4181-816d-96b71bf533cc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "rating": "5",
      "name": " Bo Eastman",
      "text": "JT & Alyxandra are very helpful and make me feel at home at Astoria. I also enjoy the quietness and nice well kept nature we have around the buildings.",
      "date": "2026-08-30",
      "title": "false"
    },
    {
      "id": "custom_a96c5396-d15c-4d43-ac48-217de42191f5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "rating": "5",
      "name": "Tramese Byrd",
      "text": "Alex was so amazing and helpful and we loved the concept of the free wheel spin once you move in to your apartment! Thank you for all the help\n",
      "date": "2026-08-29",
      "title": "false"
    },
    {
      "id": "custom_b2c0c4fe-3587-45f8-9429-225993b95b73",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "rating": "5",
      "name": " Amanda Hall",
      "text": "Shellise and Cassy are both wonderful and made the moving process smooth!\n",
      "date": "2026-05-08",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_d51d6439-c9c8-4f5a-8c05-194c4a470e29",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d3-7808-7644-b959-d96fc8836116.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Kitchen area with dishwasher, sink, and cabinets.",
        "public_id": "019d02d3-7808-7644-b959-d96fc8836116",
        "storage_key": "property/6767906449166811/019d02d3-7808-7644-b959-d96fc8836116.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Astoria Apartments | Adams 2BR / 1BA",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=txHnCtDrtvT"
    },
    {
      "id": "custom_a98ba7c3-fdbd-49e5-a869-b6ce0d4ec097",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d3-7805-777a-b026-a1ddbea1b258.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Spacious living room with a gray tufted sofa, coffee table, and mounted TV.",
        "public_id": "019d02d3-7805-777a-b026-a1ddbea1b258",
        "storage_key": "property/6767906449166811/019d02d3-7805-777a-b026-a1ddbea1b258.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Astoria Apartments - 2BR / 1BA",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=E5g8DJN2Pzq&brand=0"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019e7466-0654-703a-b40b-6153359b0acb",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "amc-astoria",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "page_item_url": "dog-park-apartments-fife-wa",
      "search_query": "dog park apartments in Fife WA",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments in Fife, WA",
      "h2_subtitle": "Live near great dog park apartments in Fife, WA. Enjoy convenient pet-friendly living in Pierce County.",
      "page_copy": "Astoria offers pet-friendly apartment living in Fife, WA, with convenient features for residents with pets. An on-site dog wash station makes it easy to care for your four-legged companion, while nearby parks and outdoor spaces provide additional opportunities to get outside and explore the Fife area.\n\nBeyond its pet-friendly features, Astoria offers a variety of community amenities designed for everyday convenience, including a fully equipped fitness center, welcoming clubhouse, on-site parking, and community playground. With modern amenities and convenient access to destinations throughout Fife and the surrounding Pierce County area, Astoria provides a comfortable place to call home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments in Fife, WA - Astoria",
      "seo_description": "Discover dog-friendly living at Astoria in Fife, WA. Enjoy amenities like a dog wash station and more. Perfect for pet lovers seeking convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "page_item_url": "luxury-fitness-center-apartments-pierce-county",
      "search_query": "luxury fitness center apartments Pierce County",
      "category": "Amenity",
      "h1_title": "Luxury Fitness Center Apartments in Pierce County",
      "h2_subtitle": "Discover luxury living with top-notch fitness amenities in Pierce County. Astoria offers the ultimate fitness center experience.",
      "page_copy": "Experience modern apartment living at Astoria, featuring a well-equipped fitness center that makes it convenient to stay active close to home. Located in Fife, WA, within Pierce County, Astoria combines thoughtfully designed amenities with convenient access to shopping, dining, recreation, and destinations throughout the surrounding area.\n\nBeyond the fitness center, residents can enjoy a variety of community amenities, including a welcoming clubhouse, convenient on-site parking, community playground, and dog wash station. From spaces for staying active to features designed for everyday convenience, Astoria offers a well-rounded amenity experience in Fife, WA.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Fitness Center Apartments - Pierce County",
      "seo_description": "Explore luxury living at Astoria with a premier fitness center in Pierce County. Enjoy upscale amenities and a vibrant community atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "page_item_url": "apartment-with-dog-wash-station-98424",
      "search_query": "apartment with dog wash station 98424",
      "category": "Amenity",
      "h1_title": "Apartment with Dog Wash Station in 98424",
      "h2_subtitle": "Searching for an apartment with a dog wash station in the 98424 area? Astoria in Fife offers pet-friendly features tailored to your needs.",
      "page_copy": "Astoria, located in the 98424 ZIP code in Fife, WA, offers pet-friendly apartment living with the convenience of an on-site dog wash station. This dedicated amenity makes it easy to care for your four-legged companion after exploring Fife, nearby parks, and other pet-friendly destinations throughout the area.\n\nIn addition to the dog wash station, Astoria offers a variety of community amenities designed for everyday convenience. Residents can enjoy a welcoming clubhouse, modern fitness center, on-site parking, and community playground. With pet-friendly features and thoughtfully designed amenities, Astoria offers a convenient apartment living experience in Fife, WA.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment with Dog Wash Station - Fife 98424",
      "seo_description": "Discover pet-friendly apartment living at Astoria in Fife, WA. Enjoy a convenient dog wash station and modern community amenities in the 98424 area.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "page_item_url": "clubhouse-apartments-near-fife-wa",
      "search_query": "clubhouse apartments near Fife WA",
      "category": "Amenity",
      "h1_title": "Clubhouse Apartments Near Fife, WA",
      "h2_subtitle": "Discover clubhouse apartments near Fife, WA, offering community-focused amenities. Astoria provides a welcoming atmosphere for all residents.",
      "page_copy": "Welcome to Astoria, where modern apartments with a clubhouse in Fife, WA offer convenient spaces to complement everyday living. The community clubhouse provides residents with a comfortable gathering space to relax, connect, and enjoy time outside their apartment home. Located in the 98424 area, Astoria also provides convenient access to shopping, dining, recreation, and destinations throughout Fife and the surrounding Pierce County area.\n\nBeyond the clubhouse, Astoria offers a variety of community amenities, including a fully equipped fitness center, on-site parking, a community playground, and a convenient dog wash station. With thoughtfully designed spaces and everyday conveniences right at home, Astoria offers a well-rounded apartment living experience in Fife, WA.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Clubhouse Apartments Near Fife, WA - Astoria",
      "seo_description": "Explore community living at Astoria near Fife, WA. Enjoy a modern clubhouse alongside a host of amenities that cater to all residents.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "page_item_url": "apartments-with-bbq-area-in-pierce-county",
      "search_query": "apartments with BBQ area in Pierce County",
      "category": "Amenity",
      "h1_title": "Apartments with BBQ Area in Pierce County",
      "h2_subtitle": "Looking for apartments with a BBQ area in Pierce County? Discover Astoria in Fife, WA, featuring a convenient outdoor BBQ area for grilling, dining, and gathering.",
      "page_copy": "Welcome to Astoria, where apartments with an outdoor BBQ area in Fife, WA provide convenient spaces for outdoor dining and gatherings close to home. The community BBQ area offers residents a dedicated space to prepare meals, spend time outdoors, and enjoy another extension of the community’s shared amenities.\n\nAstoria also offers a variety of community features designed for everyday convenience, including a welcoming clubhouse, modern fitness center, on-site parking, community playground, and dog wash station. Located in Fife within Pierce County, Astoria combines modern apartment living with indoor and outdoor amenities designed to complement your day-to-day routine.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with BBQ Area in Pierce County",
      "seo_description": "Discover Astoria in Fife, WA, offering apartments with a BBQ area and a variety of modern amenities for comfortable, convenient living in Pierce County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-fife-wa",
      "search_query": "one bedroom apartments fife wa",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Fife, WA",
      "h2_subtitle": "Explore modern one-bedroom apartments in Fife, WA at Astoria, featuring thoughtfully designed floor plans that combine comfort, convenience, and contemporary living.",
      "page_copy": "Astoria offers thoughtfully designed one-bedroom apartments in Fife, WA, combining modern style, comfort, and functionality. Each floor plan provides a comfortable space to relax and recharge, with contemporary features designed to complement everyday living. With convenient access to shopping, dining, recreation, and destinations throughout Fife and Pierce County, Astoria puts everyday conveniences within easy reach.\n\nResidents can also enjoy a variety of community amenities, including a stylish clubhouse, well-equipped fitness center, convenient dog wash station, community playground, and on-site parking. From thoughtfully designed apartment homes to convenient shared amenities, Astoria offers a well-rounded living experience in Fife, WA.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Fife, WA - Astoria",
      "seo_description": "Discover the perfect one-bedroom apartments at Astoria in Fife, WA. Enjoy modern living with access to a range of amenities and community features.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "page_item_url": "two-bedroom-floorplans-pierce-county",
      "search_query": "two bedroom floorplans pierce county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Floorplans in Pierce County",
      "h2_subtitle": "Discover spacious two-bedroom apartments at Astoria in Fife, WA, featuring thoughtfully designed floor plans that combine comfort and functionality in Pierce County.",
      "page_copy": "Astoria offers modern two-bedroom apartments in Fife, WA, with thoughtfully designed floor plans that balance style, comfort, and functionality. Each apartment features comfortable living spaces and modern finishes, providing added flexibility for everyday living, entertaining, working from home, and relaxing. Located in Pierce County, Astoria also provides convenient access to shopping, dining, recreation, and destinations throughout the surrounding area.\n\nResidents can enjoy a variety of community amenities, including a welcoming clubhouse, a well-equipped fitness center, a community playground, on-site parking, and a convenient dog wash station. With modern apartment features and everyday conveniences right at home, Astoria offers a well-rounded living experience in Fife, WA.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Floorplans in Pierce County - Astoria",
      "seo_description": "Explore Astoria's two-bedroom floor plans in Pierce County. Enjoy modern living with community-focused amenities in a vibrant location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-near-98424",
      "search_query": "three bedroom apartments near 98424",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 98424",
      "h2_subtitle": "Discover spacious three-bedroom apartments at Astoria in Fife, WA 98424, featuring thoughtfully designed floor plans with comfortable living spaces and modern features.",
      "page_copy": "Astoria offers spacious three-bedroom apartments in Fife, WA, with thoughtfully designed floor plans that combine modern style, comfort, and functionality. The additional living space provides flexibility for a variety of everyday needs, with comfortable areas for relaxing, entertaining, working from home, and more.\n\nLocated in the 98424 area, Astoria also offers a variety of convenient community amenities, including a stylish clubhouse, fully equipped fitness center, community playground, on-site parking, and dog wash station. With modern apartment features and thoughtfully designed shared spaces, Astoria provides a well-rounded apartment living experience in Fife, WA.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near 98424 - Astoria",
      "seo_description": "Discover three-bedroom apartments at Astoria in Fife, WA 98424, offering comfortable floor plans and convenient community amenities for modern apartment living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "page_item_url": "apartments-near-university-of-washington-tacoma",
      "search_query": "apartments near university of washington tacoma pierce county",
      "category": "School",
      "h1_title": "Apartments Near UW Tacoma, Pierce County",
      "h2_subtitle": "Discover apartments near the University of Washington Tacoma at Astoria, offering modern amenities and convenient access to UW Tacoma and destinations throughout Pierce County.",
      "page_copy": "Astoria offers modern apartment living with convenient access to the University of Washington Tacoma and destinations throughout Pierce County. Located in Fife, WA, the community provides access to UW Tacoma as well as nearby shopping, dining, entertainment, major roadways, and other destinations throughout the Tacoma area.\n\nResidents at Astoria can enjoy a variety of community amenities designed for everyday convenience, including a well-equipped fitness center, welcoming clubhouse, on-site parking, community playground, and dog wash station. With thoughtfully designed apartment homes, convenient amenities, and access to destinations throughout Fife and Tacoma, Astoria offers a well-rounded living experience in Pierce County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near UW Tacoma, Pierce County - Astoria",
      "seo_description": "Discover apartments near the University of Washington Tacoma at Astoria, offering convenient access to the campus and destinations throughout Pierce County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "page_item_url": "apartments-near-st-joseph-medical-center",
      "search_query": "apartments near st. joseph medical center pierce county",
      "category": "Hospital",
      "h1_title": "Apartments Near St. Joseph Medical Center",
      "h2_subtitle": "Discover apartments near St. Joseph Medical Center at Astoria, offering modern comfort, convenient amenities, and access to destinations throughout Pierce County.",
      "page_copy": "Astoria offers modern apartment living with convenient access to St. Joseph Medical Center and destinations throughout Pierce County. Located in Fife, WA, the community provides access to the medical center as well as nearby shopping, dining, recreation, major roadways, and destinations throughout the Tacoma area.\n\nResidents at Astoria can enjoy a variety of community amenities designed for everyday convenience, including a well-equipped fitness center, a welcoming clubhouse, a dog wash station, on-site parking, and a community playground. With modern apartment homes, convenient amenities, and access to destinations throughout Fife and Tacoma, Astoria offers a well-rounded living experience in Pierce County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near St. Joseph Medical Center - Astoria",
      "seo_description": "Explore modern apartments near St. Joseph Medical Center at Astoria, offering convenient amenities and access to destinations throughout Pierce County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "page_item_url": "apartments-close-to-multicare-tacoma-general",
      "search_query": "apartments close to multicare tacoma general hospital fife",
      "category": "Hospital",
      "h1_title": "Apts Close to MultiCare Tacoma General Hospital",
      "h2_subtitle": "Explore convenient apartments close to MultiCare Tacoma General Hospital in Fife. Astoria provides easy commutes and a vibrant community.",
      "page_copy": "Astoria offers convenient apartment living with access to MultiCare Tacoma General Hospital and destinations throughout the Fife and Tacoma area. With a location that makes it easy to reach nearby employers, healthcare facilities, shopping, dining, and major roadways, Astoria combines everyday convenience with thoughtfully designed apartment living.\n\nResidents can enjoy a variety of community amenities, including a fitness center, welcoming clubhouse, on-site parking, community playground, and convenient dog wash station. Whether you're relaxing at home, staying active, or exploring nearby Fife and Tacoma, Astoria provides the features and location to complement your day-to-day routine.\n",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near MultiCare Tacoma General - Astoria",
      "seo_description": "Find convenient apartments close to MultiCare Tacoma General Hospital in Fife at Astoria, offering a vibrant community and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "page_item_url": "apartments-near-dash-point-state-park-fife-wa",
      "search_query": "apartments near Dash Point State Park Fife WA",
      "category": "Park",
      "h1_title": "Apts Near Dash Point State Park, Fife WA",
      "h2_subtitle": "Find serene apartments near Dash Point State Park in Fife, WA at Astoria, blending nature with modern amenities.",
      "page_copy": "Discover a blend of natural surroundings and modern apartment living at Astoria, conveniently located near Dash Point State Park in Fife, WA. With the park’s scenic landscapes, trails, and outdoor recreation nearby, residents have convenient access to one of the area’s popular destinations while enjoying the comforts of contemporary apartment living.\n\nAstoria also offers a variety of community amenities designed for everyday convenience and enjoyment, including a fitness center, welcoming clubhouse, community playground, and convenient dog wash station. From exploring the outdoors at nearby Dash Point State Park to enjoying the amenities right at home, Astoria offers a convenient connection to both recreation and modern living in the Fife area.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Dash Point State Park, Fife WA - Astoria",
      "seo_description": "Explore Astoria's serene apartments near Dash Point State Park, Fife WA, offering nature and modern amenities for a balanced lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "page_item_url": "rentals-close-to-wright-park-pierce-county",
      "search_query": "rentals close to Wright Park Pierce County",
      "category": "Park",
      "h1_title": "Rentals Close to Wright Park, Pierce County",
      "h2_subtitle": "Discover rentals close to Wright Park in Pierce County at Astoria, combining central living and outdoor enjoyment.",
      "page_copy": "Astoria offers convenient apartment living with access to Wright Park and destinations throughout Pierce County. Wright Park features expansive green space, walking paths, gardens, and opportunities to enjoy the outdoors, adding another recreational destination within reach of the community.\n\nAt Astoria, residents can enjoy a variety of amenities designed for everyday convenience, including a fully equipped fitness center, welcoming clubhouse, community playground, and dog wash station. Whether exploring Wright Park or enjoying the amenities at home, Astoria provides a convenient location for experiencing Fife, Tacoma, and the surrounding Pierce County area.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Wright Park, Pierce County - Astoria",
      "seo_description": "Experience modern rentals close to Wright Park in Pierce County with Astoria's amenities and vibrant lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "page_item_url": "housing-near-wapato-park-98424",
      "search_query": "housing near Wapato Park 98424",
      "category": "Park",
      "h1_title": "Housing Near Wapato Park, 98424",
      "h2_subtitle": "Explore comfortable housing near Wapato Park in the 98424 area. Astoria offers a blend of relaxation and convenience in Fife, WA.",
      "page_copy": "Astoria offers modern apartment living near Wapato Park with convenient access to destinations throughout the 98424 area and greater Pierce County. Nearby Wapato Park features a picturesque lake, scenic walking trails, gardens, and green spaces, providing opportunities to enjoy outdoor recreation within the Tacoma area.\n\nAt Astoria, residents can enjoy a variety of community amenities, including a fitness center, welcoming clubhouse, community playground, and convenient dog wash station. With access to nearby outdoor destinations like Wapato Park as well as shopping, dining, and everyday conveniences throughout Fife and Tacoma, Astoria connects modern apartment living with the surrounding Pierce County area.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Housing Near Wapato Park, 98424 - Astoria",
      "seo_description": "Discover Astoria's convenient housing options near Wapato Park in the 98424 area, featuring modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "page_item_url": "apartments-by-celebration-park-wa",
      "search_query": "apartments by Celebration Park WA",
      "category": "Park",
      "h1_title": "Apartments by Celebration Park, WA",
      "h2_subtitle": "Experience exceptional living in apartments by Celebration Park, WA with Astoria, where lively outdoor adventures await.",
      "page_copy": "Astoria offers modern apartment living near Celebration Park, providing convenient access to one of the area’s popular destinations for outdoor recreation. Celebration Park features expansive green spaces, sports fields, walking paths, and event areas, offering plenty of opportunities to spend time outdoors and explore the surrounding area.\n\nAt Astoria, residents can enjoy a variety of community amenities, including a modern fitness center, welcoming clubhouse, community playground, and convenient dog wash station. With Celebration Park nearby and access to shopping, dining, recreation, and everyday conveniences throughout the surrounding area, Astoria brings together a convenient location and modern apartment living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Celebration Park, WA - Astoria",
      "seo_description": "Find perfect living at Astoria's apartments by Celebration Park, WA. Enjoy modern amenities and easy park access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "page_item_url": "astoria-near-bradley-lake-park-pierce-county",
      "search_query": "Astoria proximity to Bradley Lake Park Pierce County",
      "category": "Park",
      "h1_title": "Astoria Near Bradley Lake Park, Pierce County",
      "h2_subtitle": "Discover the convenience of Astoria's proximity to Bradley Lake Park in Pierce County, offering scenic views and modern amenities.",
      "page_copy": "Astoria offers modern apartment living with convenient access to Bradley Lake Park and destinations throughout Pierce County. Bradley Lake Park features a lake, walking trails, picnic areas, open green spaces, and opportunities for outdoor recreation, providing another nearby destination to explore and enjoy.\n\nResidents at Astoria can enjoy a variety of community amenities, including a fully equipped fitness center, welcoming clubhouse, community playground, and convenient dog wash station. With access to nearby parks, recreation, shopping, dining, and everyday conveniences, Astoria combines modern apartment living with a location that makes it easy to explore the surrounding Pierce County area.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Astoria Near Bradley Lake Park - Pierce County",
      "seo_description": "Astoria offers proximity to Bradley Lake Park in Pierce County with modern amenities and scenic experiences.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166811",
      "source": "custom",
      "page_item_url": "apartments-near-tacoma-dome-fife",
      "search_query": "apartments near Tacoma Dome Fife",
      "category": "Transit",
      "h1_title": "Apartments Near Tacoma Dome, Fife",
      "h2_subtitle": "Explore life's possibilities with apartments near Tacoma Dome, in Fife. Astoria offers vibrant living just steps away from entertainment and culture.",
      "page_copy": "Astoria offers modern apartment living with convenient access to the Tacoma Dome and entertainment destinations throughout the Tacoma area. Located nearby in Tacoma, the Tacoma Dome hosts concerts, sporting events, live entertainment, and other major events throughout the year, adding a popular regional destination within easy reach of Astoria.\n\nResidents at Astoria can also enjoy a variety of community amenities, including a fitness center, spacious clubhouse, community playground, and convenient dog wash station. With access to entertainment, dining, shopping, recreation, and major destinations throughout Fife and Tacoma, Astoria combines contemporary apartment living with a convenient Pierce County location.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Tacoma Dome, Fife - Astoria",
      "seo_description": "Live close to entertainment at Astoria's apartments near Tacoma Dome in Fife, featuring modern amenities and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "lindseye@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "6019"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10715005109"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-5PKHLL93"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Pathfinder 2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Pathfinder Preferred"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_aim_property_code",
      "type": "STRING",
      "value": "184AST"
    },
    {
      "ID": "custom_anyonehome_chatbot",
      "type": "STRING",
      "value": "<link rel='stylesheet' href='https://www.myshowing.com/css/omnichannel/omnichannel_communication.css'> <script src='https://www.myshowing.com/js/omnichannel/omnichannel_communication.js'></script><script text='text/javascript'>window.OmniChannel.init('MqIyDhXQ93NoqV216b')</script>"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "41607311715"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/1ywy8ydyvq0"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "22009716"
    },
    {
      "ID": "custom_website_tracking_email",
      "type": "STRING",
      "value": "amcllc_astoria_web_propertywebsite@leads.anyonehome.com"
    },
    {
      "ID": "custom_anyonehome_scheduler_url",
      "type": "STRING",
      "value": "https://www.myshowing.com/AMC LLC/Astoria/scheduletourwidget/6uBWoOi5kMwRljma7H/"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IndGWHR1MVlhZytyWFdRblpzUDU4YlE9PSIsInZhbHVlIjoiN3NIc2VQNUIxQzRTS3FtOVVHOFM3Zz09IiwibWFjIjoiNmFmOGM2ZGQ3MWVkZGI0Zjg0MzgxMmM1ZjA1MDI2Yzc5MTJlMDBlZDQ4YWY1OWM4YTA5NTU0NWE1MGVmODk5NiJ9"
    }
  ],
  "custom_csm": "lindseye@repli360.com",
  "custom_qb_id": "6019",
  "custom_repli_id": "10715005109",
  "custom_google_gtm_id": "GTM-5PKHLL93",
  "custom_rollout_phase": "Pathfinder 2",
  "custom_vibesites_theme": "Pathfinder Preferred",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "full_stack",
  "custom_aim_property_code": "184AST",
  "custom_anyonehome_chatbot": "<link rel='stylesheet' href='https://www.myshowing.com/css/omnichannel/omnichannel_communication.css'> <script src='https://www.myshowing.com/js/omnichannel/omnichannel_communication.js'></script><script text='text/javascript'>window.OmniChannel.init('MqIyDhXQ93NoqV216b')</script>",
  "custom_hubspot_company_id": "41607311715",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/1ywy8ydyvq0",
  "custom_website_subscription": "turnkey",
  "custom_broker_license_number": "22009716",
  "custom_website_tracking_email": "amcllc_astoria_web_propertywebsite@leads.anyonehome.com",
  "custom_anyonehome_scheduler_url": "https://www.myshowing.com/AMC LLC/Astoria/scheduletourwidget/6uBWoOi5kMwRljma7H/",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IndGWHR1MVlhZytyWFdRblpzUDU4YlE9PSIsInZhbHVlIjoiN3NIc2VQNUIxQzRTS3FtOVVHOFM3Zz09IiwibWFjIjoiNmFmOGM2ZGQ3MWVkZGI0Zjg0MzgxMmM1ZjA1MDI2Yzc5MTJlMDBlZDQ4YWY1OWM4YTA5NTU0NWE1MGVmODk5NiJ9",
  "custom_audioeye_site_id": "ab688c0c-2e7c-4999-81e3-f4b4a52c2e16",
  "custom_audioeye_site_hash": "32d9985a9118b0a27133af11fd1bdbec"
};

export const generatedAt = '2026-10-08T21:33:15.420Z';
